{
  "LOGIN_PAGE": {
    "TITLE": {
      "HEADER": "Connectez-vous",
      "EMAIL": "Email",
      "PASSWORD": "Mot de passe",
      "COLLABORATOR": "Collaborateur",
      "FIRSTNAME": "Prénom",
      "LASTNAME": "Nom"
    },
    "BUTTON": {
      "SUBMIT": "Me connecter",
      "SUBMIT_COLLABORATOR": "S’identifier",
      "ADD_NEW_COLLABORATOR": "Ajouter un collaborateur",
      "ADD_COLLABORATOR": "Ajouter un collaborateur",
      "HELP": "Besoin d'aide ?",
      "ADD_ACCOUNT": "Inscription",
      "FORGOT_PASSWORD": "Mot de passe oublié ?"
    },
    "INPUT": {
      "SELECT_COLLABORATOR": "Sélectionnez un collaborateur",
      "ADD_COLLABORATOR": "Crée le collaborateur"
    },
    "MESSAGE": {
      "SUCCESS": "Connexion réussie",
      "ERROR": "Identifiant incorrect"
    }
  },
  "LOGIN_ADD_COLLABORATOR": {
    "MESSAGE": {
      "SUCCESS": "Le collaborateur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le collaborateur"
    }
  },
  "LOGIN_FORGOT_PASSWORD": {
    "TITLE": {
      "HEADER": "Récupérer votre mot de passe",
      "EMAIL": "Email"
    },
    "BUTTON": {
      "SUBMIT": "Envoyer ma demande"
    },
    "MESSAGE": {
      "SUCCESS": "Une demande de réinitialisation de mot de passe à été envoyé à l'email saisie si le mail est rattaché à un compte Boomerang.",
      "ERROR": {
        "CAPTCHA": "Captcha invalid"
      }
    }
  },
  "LOGIN_REGISTER": {
    "TITLE": {
      "HEADER": "Formulaire d'inscription",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": {
        "TITLE": "Numéro de téléphone",
        "LABEL": "Numéro",
        "COUNTRY": "Pays"
      },
      "COMPANY_NAME": "Nom de l'entreprise",
      "WHICH_MARKET": "Quel est le magasin concerné ?",
      "JOB_DETAILS": "Quelle est la description de votre poste ?",
      "GEOGRAPHICAL": "Zone géographique couverte",
      "USER_JOB": "Fonction dans l'entreprise",
      "MANAGER_EMAIL": "Adresse e-mail du responsable",
      "CGU": "CGU",
      "QUESTION_CGU": "J'ai pris connaissance des",
      "CHIPS_MESSAGE": "autres",
      "CHIP_MESSAGE": "autre"
    },
    "BUTTON": {
      "SUBMIT": "Envoyer ma demande"
    },
    "MESSAGE": {
      "SUCCESS": "Demande d'inscription bien transmise",
      "NO_DATA": "Aucune donnée",
      "ERROR": {
        "CAPTCHA": "Captcha invalid",
        "TOS": " Accepter les CGU pour continuer",
        "502": "Impossible de communiquer avec le serveur",
        "JOB_TYPE": "Le type de job spécifié est invalide"
      }
    },
    "SELECT_FIELD_TEXT": {
      "ROLE": "Sélectionnez la fonction d'entreprise",
      "GEOGRAPHICAL_ZONE": "Sélectionnez une zone géographique"
    }
  },
  "RESET_PASSWORD": {
    "TITLE": "Renseignez votre mot de passe",
    "PASSWORD": "Nouveau mot de passe",
    "CONFIRM_PASSWORD": "Confirmez votre mot de passe",
    "SUCCESS": "Mot de passe changée avec succès",
    "ERROR": "Nous n'avons pas pu valider votre demande, car elle a dépassé les 60 minutes. Merci de refaire une demande de réinitialisation de mot de passe.",
    "BUTTON": {
      "SUBMIT": "Réinitialiser mon mot de passe"
    }
  },
  "INIT_PASSWORD": {
    "TITLE": "Renseignez votre mot de passe",
    "PASSWORD": "Nouveau mot de passe",
    "CONFIRM_PASSWORD": "Confirmez votre mot de passe",
    "SUCCESS": "Mot de passe crée avec succès",
    "ERROR": "Nous n'avons pas pu valider votre demande, car elle a dépassé les 7 jours. Merci de refaire une demande de réinitialisation de mot de passe.",
    "BUTTON": {
      "SUBMIT": "Modifier"
    }
  },
  "PROFILE_PAGE": {
    "TITLE": {
      "HEADER": "Édition du profil",
      "SUBTITLE": "Formulaire d'édition du profil"
    },
    "FORM": {
      "PERSONAL_INFO": "Information personnelle",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_PHONE": "Téléphone",
      "LABEL_EMAIL_LOGIN": "Email / Login",
      "CONNECTION_INFO": "Information connexion",
      "LABEL_CURRENT_PASSWORD": "Mot de passe actuel",
      "LABEL_NEW_PASSWORD": "Nouveau mot de passe",
      "LABEL_CONFIRM_PASSWORD": "Confirmation mot de passe"
    },
    "TABLE": {
      "COLLABORATORS": "Collaborateurs",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "STATUS": "Statut",
      "LOADING_COLLABORATOR": "Chargement des collaborateurs...",
      "NO_COLLABORATOR": "Aucun collaborateur",
      "NO_JOB_DESCRIPTION": "Non renseigné"
    },
    "DIALOGUE": {
      "TITLE": "Supprimer un collaborateur",
      "MESSAGE": "Voulez-vous vraiment supprimer %{collaborator}?",
      "WARNING": "Cette action est irréversible."
    },
    "BUTTON": {
      "ADD_COLLABORATOR": "Créer un collaborateur",
      "UPDATE_COLLABORATOR": "Mettre à jour",
      "VALIDATE": "Valider l'édition du profil",
      "VALIDATE_PASSWORD": "Valider l'édition du mot de passe"
    },
    "MESSAGE": {
      "SUCCESS": "Le profil a été modifié avec succès",
      "SUCCESS_ACTIVE": "Collaborateur activé",
      "SUCCESS_INACTIVE": "Collaborateur supprimé",
      "ERROR": "Impossible de modifier le profil",
      "ERROR_PASSWORD": "Mot de passe incorrect"
    }
  },
  "COLLABORATOR_PAGE": {
    "TABLE": {
      "FIRSTNAME": "Prénom",
      "LASTNAME": "Nom",
      "ROLE": "Fonction",
      "STATUS": "Statut",
      "LOADING_USER": "Chargement des utilisateurs...",
      "NO_USER": "Aucun utilisateur"
    },
    "BUTTON": {
      "DETAIL": "Détails",
      "UPDATE": "Mettre à jour"
    }
  },
  "CREATE_COLLABORATOR": {
    "TITLE": {
      "HEADER": "Création d'un collaborateur",
      "SUBTITLE": "Formulaire de création d'un collaborateur"
    },
    "PERSONAL_INFO": "Information personnelle",
    "FIRSTNAME": "Prénom",
    "LASTNAME": "Nom",
    "JOB_DESCRIPTION": "Métier",
    "BUTTON": {
      "CREATE": "Ajouter"
    },
    "ERROR": {
      "USER_EXIST": "Utilisateur déjà existant"
    }
  },
  "EDIT_COLLABORATOR": {
    "TITLE": {
      "HEADER": "Édition d'un collaborateur",
      "SUBTITLE": "Formulaire de d'édition d'un collaborateur"
    },
    "PERSONAL_INFO": "Information personnelle",
    "FIRSTNAME": "Prénom",
    "LASTNAME": "Nom",
    "JOB_DESCRIPTION": "Métier",
    "BUTTON": {
      "UPDATE": "Mettre à jour"
    },
    "ERROR": {
      "NO_COLLABORATOR": "Le collaborator n'existe pas",
      "USER_EXIST": "Utilisateur déjà existant"
    },
    "SUCCESS": "Le collaborateur a été mis à jour avec succès."
  },
  "ERROR_INPUT": {
    "EMAIL": {
      "EMPTY": "L'email ne peut pas être vide",
      "INVALID": "Entrez un email valide",
      "MAX_LENGTH": "Le nombre de caractères maximum a été dépassé"
    },
    "MAX_LENGTH": "Le nombre de caractères maximum a été dépassé",
    "PHONE": "Le champ du téléphone n'est pas dans le bon format",
    "PHONE_PREFIX": "Le numéro de téléphone doit commencer par 06 ou 07",
    "PASSWORD": {
      "EMPTY": "Le mot de passe ne peut pas être vide",
      "ERROR_LENGTH": "Longueur minimum 12 caractères",
      "ERROR_UPPERCASE": "Doit contenir au moins une lettre majuscule",
      "ERROR_LOWERCASE": "Doit contenir au moins une lettre minuscule",
      "ERROR_DIGIT": "Doit contenir au moins un chiffre",
      "ERROR_SPECIAL_CHAR": "Doit contenir au moins un des caractères spéciaux suivant : {'!@#$%^&*(),.?\":{}|<>'}",
      "DIFFERENT_PASSWORD": "Les mots de passe doivent être identiques"
    },
    "PHONE_NUMBER": "Le champ n'est pas un numéro de téléphone valide (exemple : 01 23 45 67 89).",
    "EMPTY": "Le champ ne peut pas être vide",
    "POSITIVE_VALUE": "Valeur positive ou égal à 0",
    "MARGIN_MAX_VALUE": "La valeur doit être inférieure ou égale à 60",
    "NOT_A_NUMBER": "Le champ doit être un nombre.",
    "MAX_FILES": "Vous ne pouvez télécharger que {max} fichiers."
  },
  "SELECT": {
    "SELECT_REGISTER": "Sélectionnez une fonction d'entreprise",
    "SELECT_USER": "Sélectionnez votre identifiant",
    "USER_ROLE": {
      "COUNTER_SALES_REPRESENTATIVE": "Vendeur comptoir",
      "TELEPHONE_SALES_REPRESENTATIVE": "Vendeur téléphonique",
      "FIELD_SALES_REPRESENTATIVE": "Vendeur itinérant",
      "NATIONAL_AFTER-SALES": "Vendeur SAV national",
      "STORE_MANAGER": "Responsable magasin",
      "GEOGRAPHICAL_MANAGER": "Manager géographique",
      "MARKET/PRODUCT_CELL": "Cellule marché/produits",
      "STORE_CELL": "Cellule magasins",
      "PURCHASING/LOGISTICS/CSRD": "Direction achat/logistique/RSE",
      "DISTRIBUTOR_DATABASE_MANAGER": "Gestionnaire BDD distributeur",
      "DISTRIBUTOR_FINANCE_TEAM": "Équipe finance distributeur"
    }
  },
  "ERROR": {
    "INVALID_FILE_TO_HEAVY_ERROR_KEY": "Le fichier est trop lourd.",
    "INVALID_BODY_ERROR_KEY": "Les données envoyés sont invalide.",
    "INVALID_TOKEN_ERROR_KEY": "Le token de connexion est invalide. Veuillez vous reconnecter.",
    "EXPIRED_TOKEN_ERROR_KEY": "Le token de connexion est expirée. Veuillez vous reconnecter.",
    "INVALID_CAPTCHA_TOKEN": "Le reCAPTCHA est invalide.",
    "INVALID_EMAIL_ERROR_KEY": "L'email est invalide.",
    "INVALID_PHONE_NUMBER_ERROR_KEY": "Le numéro de téléphone est invalide",
    "INVALID_PASSWORD_ERROR_KEY": "Le mot de passe renseigné est invalide",
    "INVALID_JOB_DESCRIPTION_ERROR_KEY": "La description du poste est invalide.",
    "INVALID_FIRSTNAME_ERROR_KEY": "Le prénom est incorrecte.",
    "INVALID_LASTNAME_ERROR_KEY": "Le nom de famille est incorrecte.",
    "INVALID_DUPLICATE_ERROR_KEY": "Impossible d'enregistrer une donnée déjà existante.",
    "INVALID_DUPLICATE_EMAIL_ERROR_KEY": "L'email renseigné est déjà existant.",
    "INVALID_DUPLICATE_BOOMERANG_ID_ERROR_KEY": "L'identifiant ID est déjà existant.",
    "NOT_FOUND_ERROR_KEY": "L'entité n'existe pas.",
    "UNEXPECTED_ERROR_KEY": "Erreur inattendue générée.",
    "INVALID_TYPE_ERROR_KEY": "Le type de compte est invalide.",
    "INVALID_ACCOUNT_ERROR_KEY": "Compte invalide.",
    "NO_MULTI_COLLABORATOR_ACCOUNT_ERROR_KEY": "Ce compte n'accepte pas plusieurs collaborateurs.",
    "INVALID_NAME_ERROR_KEY": "Le nom est invalide.",
    "INVALID_NUMBER_ERROR_KEY": "Le nombre est invalide.",
    "EMPTY_LIST_ERROR_KEY": "La liste des codes région ne peut pas être vide.",
    "NOT_EMPTY_LIST_ERROR_KEY": "Ce rôle est encore utilisé par certains comptes.",
    "INVALID_BOOMERANG_ID_ERROR_KEY": "L'identifiant Boomerang est invalide.",
    "INVALID_TITLE_ERROR_KEY": "Le titre est invalide.",
    "INVALID_ROLE_TYPE_ERROR_KEY": "Le type du rôle doit être 'Administrateur' ou 'Distributeur'",
    "USER_ALREADY_EXISTS_ERROR_KEY": "L'utilisateur existe déjà.",
    "INVALID_DUPLICATE_ROLE_TITLE_ERROR_KEY": "Le titre du rôle est déjà existant.",
    "INVALID_NEW_CONFIRM_PASSWORD_ERROR_KEY": "Les mots de passe ne sont pas identiques.",
    "INVALID_GUARANTEE_ERROR_KEY": "Aucune garantie trouvée",
    "TOO_MANY_REPAIR_CENTER_FOUND_ERROR_KEY": "Trop de centres de réparation trouvés.",
    "REPAIR_CENTER_NOT_FOUND_ERROR_KEY": "Centre de réparation introuvable.",
    "REPAIR_FILE_NOT_FOUND_ERROR_KEY": "Dossier de réparation introuvable.",
    "STORE_NOT_FOUND_ERROR_KEY": "Magasin introuvable.",
    "TRANSPORT_PACKAGE_NOT_FOUND_ERROR_KEY": "Forfait de transport introuvable.",
    "PRODUCT_NOT_FOUND_ERROR_KEY": "Produit introuvable.",
    "PACKAGE_NOT_FOUND_ERROR_KEY": "Forfait introuvable.",
    "EMAIL_CLIENT_ERROR_KEY": "L'adresse email du client n'est pas valide",
    "EMAIL_PREPARER_ERROR_KEY": "L'adresse email du préparateur logistique n'est pas valide",
    "EMAIL_COMMERCIAL_ERROR_KEY": "L'adresse email de l'équipe commerciale n'est pas valide",
    "PRODUCT_DOES_NOT_EXIST_ERROR_KEY": "Produit introuvable.",
    "INVALID_EXTENSION_GUARANTEE_BOOMERANG_ERROR_KEY": "Le numero de serie de ce produit possède déjà une prolongation de garantie.",
    "INVALID_REPAIRER_REPAIR_FILE_NUMBER_ERROR_KEY": "Le numéro de dossier de réparation est invalide.",
    "TRANSPORTER_NOT_FOUND_ERROR_KEY": "Aucun transporteur trouvé pour ce dossier",
    "TRANSPORTER_COLLECT_ERROR_KEY": "Ramasse impossible ce jour : merci de selectionner une autre date.",
    "CHRONOPOST_GENERIC_ERROR_KEY": "Erreur serveur Chronopost",
    "INVALID_CONSTRAINTS_ERROR_KEY": "La collecte sur cette adresse postale n'est pas disponible actuellement, merci de modifier l'adresse ou de réessayer plus tard.",
    "EXPRESSIST_TRANSPORTER_LINK_ALREADY_EXIST_ERROR_KEY": "Une connexion avec ce transporteur est déjà existante",
    "EXPRESSIST_TRANSPORTER_LINK_NOT_FOUND_ERROR_KEY": "Aucun transporteur paramétré",
    "INVALID_REAL_DELIVERY_DATE_ERROR_KEY": "La date de remise est invalide.",
    "INVALID_ATTACHMENT_PROOF_TYPE": "Type de la pièce jutificative est invalide",
    "INVALID_COMPANY_NAME_ERROR_KEY": "Le nom de l'entreprise est invalide",
    "INVALID_DEPOSIT_DATE_ERROR_KEY": "La date de depot est invalide",
    "INVALID_SERIAL_NUMBER_ERROR_KEY": "Le numéro de série est invalide",
    "INVALID_PRODUCT_CONDITION_NOT_FOUND_ERROR_KEY": "L'état du produit est introuvable",
    "INVALID_REPAIR_FILE_NOT_FOUND_ERROR_KEY": "Le dossier de réparation est introuvable",
    "INVALID_RECYCLING_FOLDER_BOOMERANG_ID_ERROR_KEY": "Le boomerang id du dossier de recyclage est invalide",
    "FAILED_UPLOAD_ERROR_KEY": "L'ajout des photos à échoué",
    "VALID_PROSPECT_PICTURE_ADDED_WITH_ERROR": "L'ajout des photos suivantes a échoué : {photoList}",
    "INVALID_RECYCLING_BOOMERANG_ID_NOT_FOUND_ERROR_KEY": "Aucun reconditionneur ou recycleur trouvé pour ce produit. Veuillez contacter l'administration Boomerang",
    "ITECH_GENERIC_ERROR_KEY": "Le service ITECH n'a pas pu délivrer une réponse complète",
    "ITECH_PRODUCT_NOT_FOUND_ERROR_KEY": "Le service ITECH à renvoyé : {params} Veuillez contacter un administrateur Boomerang",
    "ITECH_CLIENT_NOT_FOUND_ERROR_KEY": "Le client est introuvable pour le service ITECH, veuillez contacter un administrateur Boomerang",
    "ITECH_DOCUMENT_INTEGRATION_ERROR_KEY": "Le service ITECH à renvoyé : {params} Veuillez contacter un administrateur Boomerang",
    "ITECH_ENVIRONMENT_NOT_CONFIGURED_ERROR_KEY": "L'environnement n'est pas paramétré sur ITECH, veuillez contacter un administrateur Boomerang",
    "NOT_FOUND_SUPPLIER_CODE_ERROR_KEY": "Besoin de remonter à BOOMERANG : Paramétrage nécessaire du compte client chez réparateur"
  },
  "ERROR_STATUS_CODE_MESSAGE": {
    "200": "Requête réussie",
    "400": "Requête incorrecte",
    "401": "Non autorisé",
    "403": "Votre session a expirée, veuillez vous identifier à nouveau",
    "404": "Page non trouvée",
    "405": "Requête inconnue",
    "413": "Ficher trop volumineux",
    "500": "Erreur interne du serveur",
    "502": "Erreur de réseau",
    "504": "Temps d'attente dépassé",
    "NOT_REDIRECT": "Redirection impossible",
    "UNKNOWN": "Une erreur inconnue est survenue"
  },
  "DISCONNECT": {
    "MESSAGE": "Vous avez été déconnecté"
  },
  "STATUS": {
    "PENDING": "En attente",
    "INACTIVE": "Inactif",
    "ACTIVE": "Actif",
    "DELETED": "Supprimé"
  },
  "JOB_LIST": {
    "STORE_SALESMAN_JOB": "Vendeur magasin",
    "TELEPHONE_SALESMAN_JOB": "Vendeur téléphonique",
    "TRAVELING_SALESMAN_JOB": "Vendeur Itinérant",
    "STORE_MANAGER_JOB": "Responsable Magasin",
    "GEOGRAPHIC_MANAGER_JOB": "Manager Géographique",
    "RSE_DEPARTMENT_JOB": "Direction RSE",
    "MARKETING_DEPARTMENT_JOB": "Direction Marketing",
    "PURCHASING_DEPARTMENT_JOB": "Direction Achat/Opérations",
    "OTHER_JOB": "Autre"
  },
  "LAYOUTS": {
    "DASHBOARD": "Accueil",
    "FOLDER": "Dossier",
    "ACCOUNTS": "Compte",
    "TRANSPORTER": "Transporteur",
    "HELP": "Aide",
    "LOGOUT": "Déconnexion",
    "NOTIFICATIONS": "Notifications",
    "PROFILE": "Collaborateur",
    "RECYCLING_REPORT": "Rapport de performance"
  },
  "MANAGEMENT_PAGE": {
    "TITLE": {
      "HEADER_USER": "Utilisateurs"
    },
    "BUTTON": {
      "NEW_ACCOUNT": "Nouvel utilisateur",
      "ACCOUNT": "Utilisateurs"
    }
  },
  "ACCOUNT_PAGE": {
    "PLACEHOLDER": {
      "ROLE": "Sélectionner le rôle",
      "STATUS": "Sélectionner le statut"
    },
    "TABLE": {
      "ID": "ID",
      "USER": "Utilisateur",
      "APPLICANT": "Demandeur",
      "ROLE": "Rôle",
      "FILE": "Nombre de dossier",
      "GROUPS": "Groupement",
      "STATUS": "Statut",
      "INFO_QUALITY": "Formation",
      "DESCRIPTION": "Description",
      "SUB_STATUS": "Sous statut",
      "ACTIVATED_DATE": "Date d'activation",
      "LOADING_USER": "Chargement des utilisateurs...",
      "NO_USER": "Aucun utilisateur",
      "OTHER": "autre",
      "OTHERS": "autres"
    }
  },
  "DETAIL_ACCOUNT_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un utilisateur",
      "COLLABORATOR": "Collaborateurs",
      "GROUPS": "Groupements",
      "STORES": "Magasins"
    },
    "LABEL": {
      "ID": "ID",
      "EMAIL": "Login / Email",
      "APPLICANT_EMAIL": "Email demandeur",
      "PHONE_NUMBER": "Numéro de téléphone",
      "STATUS": "Statut",
      "ROLE": "Rôle",
      "NETWORK": "Réseau",
      "AREA": "Zone géographique",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "NOT_SPECIFIED": "Non renseigné",
      "ACTIVATION_DATE": "Date d'activation",
      "FORMATION_ONE": "Première formation",
      "FORMATION_TWO": "Seconde formation",
      "FORMATION_THREE": "Troisième formation",
      "DESCRIPTION": "Description",
      "SUB_STATUS": "Sous statut"
    },
    "TABLE": {
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "STATUS": "Statut",
      "DATE": "Date",
      "LOADING_COLLABORATORS": "Chargement des collaborateurs...",
      "NO_COLLABORATOR": "Aucun collaborateur",
      "GROUP_NAME": "Groupement",
      "STORE_NAME": "Magasin"
    },
    "BUTTON": {
      "NEW_COLLABORATOR": "Ajouter un collaborateur"
    },
    "MESSAGE": {
      "SUCCESS": "",
      "ERROR": ""
    },
    "MODAL": {
      "TITLE": "Supprimer un collaborateur",
      "MESSAGE": "Voulez-vous vraiment supprimer %{collaborator}?",
      "WARNING": "Cette action est irréversible."
    }
  },
  "EDIT_ACCOUNT_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un utilisateur",
      "SUBTITLE": "Formulaire d'édition d'un utilisateur"
    },
    "FORM": {
      "LABEL_ACCOUNT_TYPE": "Type de compte",
      "ACCOUNT_INFO": "Information demandeur",
      "ADDITIONAL_INFO": "Information complementaire",
      "USER_SCOPE": "Périmètre utilisateur",
      "LABEL_ID": "ID",
      "LABEL_PHONE": "Téléphone",
      "LABEL_EMAIL": "Login / Email",
      "LABEL_APPLICANT_EMAIL": "Email demandeur",
      "LABEL_STATUS": "Statut",
      "LABEL_FORMATION_ONE": "Première formation",
      "LABEL_FORMATION_TWO": "Seconde formation",
      "LABEL_FORMATION_THREE": "Troisième formation",
      "LABEL_DESCRIPTION": "Description",
      "LABEL_SUB_STATUS": "Sous statut",
      "LABEL_ROLE": "Rôle",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUPS": "Groupements",
      "LABEL_STORES": "Magasins",
      "SOLO": "Compte simple",
      "MULTIPLE": "Compte multiple",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition de l'utilisateur"
    },
    "MESSAGE": {
      "SUCCESS": "L'utilisateur a été modifié avec succès",
      "ERROR": "Impossible de modifier l'utilisateur"
    }
  },
  "COMMON": {
    "FILTER": {
      "SEARCH": "Rechercher",
      "EXPORT": "Exporter",
      "SHOW_FILTERS": "Afficher les filtres"
    },
    "MESSAGE": {
      "ADD_ATTACHMENT_SUCCESS": "La pièce jointe a été ajoutée avec succès.",
      "REMOVE_ATTACHMENT_SUCCESS": "La pièce jointe a été supprimée avec succès."
    },
    "BUTTON": {
      "YES": "Oui",
      "NO": "Non",
      "NEXT_STEP": "Prochaine étape",
      "BACK": "Retour",
      "DETAIL": "Détails",
      "UPDATE": "Mettre à jour",
      "CREATE": "Créer",
      "DELETE": "Supprimer",
      "LOAD_MORE": "Charger plus",
      "CANCEL": "Annuler",
      "CONTINUE": "Continuer",
      "SAVE": "Enregistrer",
      "VALIDATE": "Valider",
      "CONFIRM": "Confirmer",
      "LEAVE": "Quitter",
      "SEND": "Envoyer",
      "RECYCLE": "Recycler",
      "FINISH": "Terminer"
    },
    "TABLE": {
      "OTHER": "autre",
      "OTHERS": "autres",
      "NO_PRODUCT": "Aucun produit"
    },
    "MULTI_SELECT": {
      "SELECT_ALL": "Tout sélectionner",
      "UNSELECT_ALL": "Tout désélectionner"
    },
    "PRODUCT_TYPE": {
      "MACHINE": "Machine",
      "BATTERY": "Batterie",
      "CHARGER": "Chargeur",
      "PRODUCT": "Produit",
      "ACCESSORY_ONE": "Accessoire 1",
      "ACCESSORY_TWO": "Accessoire 2",
      "BRIEFCASE": "Malette",
      "PREMIUM_CONSUMABLE": "Consommable Premium",
      "PPE": "Équipement de protection individuelle",
      "EQUIPMENT": "Équipement",
      "PALLET": "Palette"
    },
    "PRICING_TYPE": {
      "PACKAGE": "Forfait",
      "ESTIMATE": "Devis"
    },
    "WORKFLOW": {
      "POWER_TOOLS": "Électroportatif",
      "GENERIC": "Générique"
    },
    "STATUS_MACRO": {
      "DRAFT": "BROUILLON",
      "IN_CREATION": "EN CRÉATION",
      "IN_CREATION_ESTIMATE": "EN CRÉATION - DEVIS",
      "IN_CREATION_PROSPECT": "EN CRÉATION - DEMANDE",
      "TRANSPORT_GO": "TRANSPORT ALLER",
      "RECEPTION_AT_REPAIRER": "RÉCEP. RÉPARATEUR",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "DIAGNOSTIC RÉPARATEUR REÇU",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "DIAGNOSTIC RÉPARATEUR TRAITÉ",
      "ESTIMATE_SENT_TO_CUSTOMER": "DECISION CLIENT - DEVIS",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "DEVIS RÉPARATEUR VALIDE",
      "IN_REPARATION": "RÉPARATION",
      "SENT_BACK_BY_REPAIRER": "TRANSPORT RETOUR",
      "RECEIPT_AT_STORE": "RÉCEP. MAGASIN",
      "SENT_AVAILABLE_TO_CUSTOMER": "ATTENTE COLLECTE",
      "TAKEOVER_BY_CUSTOMER": "CLOTURÉ",
      "NETWORK_BILLING": "FACTURATION",
      "FINISHED": "TERMINÉ",
      "ABORT_BY_CUSTOMER": "ABANDON PAR CLIENT",
      "DELETED": "SUPPRIMÉ"
    },
    "STATUS_DETAIL": {
      "GUARANTEE_EVALUATED": "Création de dossier",
      "PRICING_SENT_TO_CUSTOMER": "Devis forfait",
      "PRICING_EVALUATED": "Création de dossier",
      "INFORMATION_RETRIEVED": "N° de commande",
      "INTERNAL_COMMAND_NUMBER_LINKED": "Sélection du transport",
      "TRANSPORTER_REPAIR_FILE_TRANSFER": "Finalisation du dossier",
      "FINALIZE_REPAIR_FILE": "Finalisation du dossier",
      "REPAIR_FILE_CREATED": "Transfert du produit",
      "COLLECTION_TO_REPAIRER": "Enlèvement Aller",
      "RECEPTION_AT_REPAIRER": "Réception chez réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "Devis envoyé par le fabricant",
      "ESTIMATE_CREATED": "Réception devis réparateur",
      "ESTIMATE_SENT_TO_CUSTOMER": "Devis envoyé au client",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "Décision client envoyée au réparateur",
      "IN_REPARATION": "En réparation",
      "SENT_BACK_BY_REPAIRER": "Expédition par réparateur",
      "RECEIPT_AT_STORE": "Réception en magasin",
      "SENT_AVAILABLE_TO_CUSTOMER": "Client informé dispo",
      "TAKEOVER_BY_CUSTOMER": "Remise au client - Cloturé",
      "NETWORK_BILLING": "Facturation",
      "FINISHED": "Terminé",
      "ABORT_BY_CUSTOMER": "Abandonné",
      "DELETED": "Supprimé"
    },
    "PRODUCT_END_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_RECYCLED": "Non réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non réparation : retour de la machine démontée",
      "DEFAULT": "Dossier sans remise client",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Echange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "emande préalable : Autre"
    },
    "EURO": "€",
    "PERCENT": "%",
    "DATE_PLACEHOLDER": "JJ/MM/AAAA",
    "DAYS": " jours",
    "DAY": " jour",
    "KILOGRAM": "kg",
    "CENTIMETER": "cm",
    "EXCLUSIVE_TAX": " (HT)",
    "NO_DATA": "Aucun résultat",
    "NO_VALUE": "-",
    "WEIGHT": "Poids",
    "WIDTH": "Largeur",
    "LENGTH": "Longueur",
    "NOT_AUTHORIZED_MESSAGE": "Vous n'êtes pas autorisé à voir cette page, merci de contacter un administrateur",
    "NOT_AUTHORIZED_ACTION_MESSAGE": "Vous n'êtes pas autorisé à effectuer cette action, merci de contacter un administrateur"
  },
  "DASHBOARD": {
    "TITLE": "Bienvenue sur Boomerang",
    "BUTTON": {
      "NEW_REPAIR_FILE": "Nouveau dossier Réparation / Prise en charge",
      "RECYCLE": "Recyclage",
      "RECONDITION": "Reconditionnés"
    },
    "FOOTER": {
      "AVERAGE_CUSTOMER": ">85%",
      "AVERAGE_RESPONSE": " de devis automatiques",
      "GUARANTEE": "Jusqu'à 6 mois de garantie Boomerang",
      "PRODUCT": "+19500 produits",
      "CATEGORY": "115 marques",
      "BUTTON": "Se former à Boomerang avec nos équipes"
    },
    "REPAIR_FILE_FINALIZED": {
      "TITLE": "Calculateur Impact écologique (en cours)",
      "CO2": "- CO²"
    }
  },
  "LEAVE_MODAL": {
    "SIMPLE_MODAL": {
      "TITLE": "Vous quittez le dossier",
      "MESSAGE": "Souhaitez-vous quitter ?",
      "VALIDATION_BUTTON": "Oui",
      "CANCEL_BUTTON": "Non"
    },
    "STEPPER_MODAL": {
      "STEP_1": {
        "TITLE": "Vous quittez le dossier",
        "VALIDATION_BUTTON": "Revenir sur la création de dossier plus tard",
        "CANCEL_BUTTON": "Abandonner le dossier et recycler"
      },
      "STEP_2": {
        "TITLE": "Pour quels motifs ?",
        "REASON": {
          "REPAIR_TOO_EXPENSIVE": "Réparation trop chère",
          "REPAIR_TOO_EXPENSIVE_AND_BUY_SAME": "Réparation trop chère et rachat d’un produit de la même marque",
          "REPAIR_TOO_EXPENSIVE_AND_BUY_OTHER": "Réparation trop chère et rachat d’un produit d'une autre marque",
          "NO_PACKAGE": "Pas de forfait",
          "OTHER": "Autre"
        },
        "RECYCLING": {
          "TITLE": "PROPOSER L'OPTION RECYCLAGE",
          "BUYBACK_MESSAGE": "Reprise jusqu'à %{buybackPrice}€ en fonction de l'état"
        },
        "LEAVE_MESSAGE": "Le dossier sera visible dans le tableau sous le statut « Abandon »"
      }
    }
  },
  "FILE_STEP_PRODUCT": {
    "TITLE": "Produit en panne",
    "SUB_TITLE": "Produits les plus populaires",
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionnez la marque",
      "CATEGORY": "Sélectionnez la gamme",
      "SUB_CATEGORY": "Sélectionnez la sous-gamme",
      "NO_PRODUCT": "Aucun produit"
    },
    "SELECT": {
      "MANUFACTURER": "Quelle est la marque du produit ?",
      "CATEGORY": "Quelle est la gamme du produit ?",
      "SUB_CATEGORY": "Quelle est la sous-gamme du produit ?"
    },
    "LABEL": {
      "PRODUCT": "Sélectionnez le produit",
      "PRODUCT_POPULAR": "Produits les plus populaires",
      "UNSELECTABLE": "À ce jour, ce produit ne peut être réparé par le fabricant.",
      "NO_REPARABLE": "Non réparable"
    },
    "BUTTON": {
      "ADD_PRODUCT": "Ajouter un produit manquant",
      "ADD_PRODUCT_QUESTION": "Vous ne trouvez pas votre produit ?"
    },
    "ASBESTOS_MODAL": {
      "TITLE": "Le produit a-t-il été exposé à l'amiante?",
      "MESSAGE": "Une produit ayant été exposé à l'amiante présente un risque. Une décontamination est nécessaire pour faire réparer un produit. Si le produit n'a pas été décontaminé, le distributeur se trouve dans l'interdiction de renvoyer le produit.",
      "MESSAGE_TWO": "Si le produit a été décontaminé, télécharger le certificat (vous avez la possiblilté de l'ajouter à la fin de la création de dossier)",
      "PLACEHOLDER": "Certificat amiante"
    },
    "STORE_MODAL": {
      "TITLE": "Sélection du magasin",
      "MESSAGE": "Sélectionnez le magasin concerné pour démarrer un dossier",
      "MESSAGE_EXPORT": "Sélectionnez le magasin concerné pour l'export des dossiers",
      "PLACEHOLDER": "Magasin"
    },
    "CARD_GENERIC": {
      "TITLE": "Ajouter un produit manquant",
      "SUB_TITLE": "L'ajout de ce produit en dehors de la sélection précédente entraine un process non accèléré et ne se verra pas proposer l'option de forfait de réparation ",
      "INPUT": {
        "NAME": "Nom du produit",
        "CODE_REF_NETWORK": "Code référence distributeur",
        "CODE_REF_MANUFACTURER": "Code référence fabricant"
      },
      "DIALOGUE": {
        "TITLE": "Dossier en cours",
        "MESSAGE": "Vous êtes sur le point de quitter la création d'un dossier.",
        "WARNING": "Êtes-vous sur de vouloir quitter?",
        "VALIDATION_BUTTON": "Oui",
        "CANCEL_BUTTON": "Non"
      },
      "BUTTON": "Aller chercher un produit"
    }
  },
  "STEPPER": {
    "TITLE": "Dossier en création",
    "STEP": {
      "ONE": "Produit",
      "TWO": "Motif de la panne",
      "THREE": "Évaluation de garantie",
      "FOUR": "Tarification",
      "FIVE": "Information client",
      "FIVE_PROSPECT": "Information interne magasin",
      "SIX": "Information interne magasin",
      "SIX_PROSPECT": "Information dossier",
      "SEVEN": "Transport"
    }
  },
  "REPAIR_FILE_RECAP": {
    "STEP_ONE": {
      "TITLE": "Produit",
      "MANUFACTURER": "Marque :",
      "CATEGORY": "Gamme :",
      "SUB_CATEGORY": "Sous-gamme :",
      "PRODUCT": "Produit :",
      "QUESTION": "Questionnaire électroportatif",
      "GENERIC_QUESTION": "Questionnaire générique"
    },
    "STEP_TWO": {
      "TITLE": "Motif de la panne",
      "BREAKDOWN": "Description de la panne :",
      "TYPE": "Éléments en panne :"
    },
    "STEP_THREE": {
      "TITLE": "Prise en charge",
      "GUARANTEE": {
        "TITLE": "Prise en charge :",
        "UNDER_GUARANTEE": "Sous garantie",
        "OUT_GUARANTEE": "Hors garantie"
      }
    },
    "STEP_FOUR": {
      "TITLE": "Tarification",
      "PACKAGE": "Forfait :",
      "ESTIMATE": "Devis :",
      "CUSTOMER_CODE": "Client / Prospect :",
      "DELAY": "Délai :",
      "DAYS": "jours",
      "ASK_ESTIMATE": "Demander un devis de réparation"
    },
    "STEP_FIVE": {
      "TITLE": "Information client",
      "NAME": "Nom / prénom :",
      "CONTACT": "Contact :"
    },
    "STEP_SIX": {
      "TITLE": "Information interne du magasin",
      "INTERNAL_COMMAND_NUMBER": "Numéro de commande fournisseur :"
    }
  },
  "FILE_STEP_BREAKDOWN": {
    "TITLE": "Motif de la panne",
    "DESCRIPTION": "Décrire le problème",
    "PRODUCT_BREAKDOWN": "Motif de la panne",
    "PLACEHOLDER": {
      "DESCRIPTION": "Apporter quelques précisions pour décrire le problème",
      "PRODUCT_BREAKDOWN": "Sélectionner un motif de panne"
    },
    "PRODUCT_QUESTION_MODAL": {
      "TITLE": "Aidez votre technicien SAV à mieux réparer votre produit",
      "SUBTITLE": "Panne : ",
      "TEST_1": "Test 1 :",
      "TEST_2": "Test 2 :"
    },
    "LABEL": {
      "AFFECTED_ELEMENT": "Élément atteints",
      "NOT_FOUND_ELEMENT": "Je ne connais pas l'élément concerné"
    },
    "DIALOG": {
      "TITLE": "Problème avec",
      "CONTENT": "Avant de déclencher une réparation, soyez persuadé que cet accessoire n'est pas la cause de la panne. Dans le cas où la réparation serait demandé et que l'accessoire sera incriminé, le fabricant vous facturera les couts de transports et ne réparera pas le produit."
    },
    "BUTTON": {
      "NOT_FOUND_BREAKDOWN": "Je ne trouve pas le motif de la panne"
    },
    "STEP_TWO": {
      "TITLE": "Produit",
      "MANUFACTURER": "Marque :",
      "CATEGORY": "Gamme :"
    }
  },
  "FILE_STEP_GUARANTEE": {
    "TITLE": "Evaluation de garantie",
    "SUB_TITLE": "Numéro de série",
    "DISTRIBUTOR_REF": "Produit acheté en pack ? Rechercher les références ci-dessous :",
    "WARNING_TITLE": "Prise en charge hors garantie",
    "SUCCESS_TITLE": "Prise en charge sous garantie",
    "GUARANTEE_TIME": "Durée de garantie standard",
    "PROOF_EXTENSION_GUARANTEE": "Justificatif de date d'extension garantie",
    "PROOF_PURCHASE_DATE": "Justificatif de date d'achat",
    "GUARANTEE_TIME_REMAINING": "Nombre de jours restants sous garantie",
    "DATE": "Date de l'achat",
    "DAYS": "Jours",
    "DAY": "Jour",
    "NO_DAY": " 0 Jour",
    "TODAY": "Moins de 24 heures",
    "END_DATE_EXTENSION_GUARANTEE": "Date de fin d'extension de garantie",
    "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
    "INPUT_LABEL_BY_PC": "Via votre ordinateur",
    "PLACEHOLDER": {
      "SEARCH": "999 999 999 999"
    },
    "BUTTON": {
      "ENFORCE_SUPPORT": "Forcer la prise en charge",
      "UNKNOWN_DATE": "Date inconnue",
      "CONTINUE": "Valider la prise en charge",
      "WITHOUT_EXTENSION": "Sans extension"
    },
    "TEXT": {
      "SERIAL_NUMBER_EXAMPLE_ONE": "Numero composé d’une suite de douze chiffres. Exemple : 852 155 682 851.",
      "SERIAL_NUMBER_EXAMPLE_TWO": "\u2028En cas d’absence de numéro de série, mettre : \u2028999 999 999 999"
    },
    "FORCE_GUARANTEE_MODAL": {
      "TITLE": "Forcer la prise en charge sous garantie",
      "MESSAGE": "Le système indique une prise en charge théorique mais le distributeur a tout à fait la possibilité de forcer la prise en charge sous garantie. Il vous faut expliquer clairement la raison au fabricant / réparateur afin qu’il puisse décider si la prise en charge est pertinente.",
      "SUB_TITLE_ONE": "Pourquoi la prise en charge devrait être sous garantie ?",
      "SUB_TITLE_TWO": "Télécharger une pièce justificative",
      "PLACEHOLDER": {
        "SUB_GUARANTEE": "Exemple : cette machine fut réparée chez le fabricant il y a 3 mois et est donc sous garantie.",
        "FILE": "Garantie, Facture de Réparation"
      },
      "BUTTON": "Envoyer"
    },
    "EXCLUSION_GUARANTEE_MODAL": {
      "TITLE": "Exclusions de la prise en charge sur ce produit",
      "BUTTON": {
        "VALID": "Valider l'évaluation"
      }
    },
    "ERROR": {
      "SERIAL_NUMBER_NOT_FOUND_FOR_EXTENSION": "Numéro de série inconnu pour l'extension de garantie",
      "SERIAL_NUMBER_NOT_FOUND_FOR_PROLONGATION": "Numéro de série inconnu pour la prolongation de garantie",
      "SERIAL_NUMBER_NOT_GOOD_FORMAT": "Le numéro doit comporter %{value} caractères",
      "SERIAL_NUMBER_NOT_UNKNOWN": "Aucun modèle de numéro de série pour ce produit"
    }
  },
  "FILE_STEP_PRICING": {
    "TITLE": "Tarification",
    "UNDER_GUARANTEE": "Produit sous garantie : prise en charge gratuite",
    "CUSTOMER_CODE": "Consultez les codes et ajustez votre forfait ci-dessous si besoin:",
    "PLACEHOLDER": {
      "CUSTOMER_CODE": "Code"
    },
    "TOOLTIP": {
      "S_1": "Augmenter le forfait :",
      "T_1": "ajouter P8 jusqu’à P50 ; le chiffre représente le montant de la hausse (P50 = +50€)",
      "S_2": "Diminuer le forfait :",
      "T_2": "ajouter M8 jusqu’à M50 ; le chiffre représente le montant de la remise (M8 = -8€)",
      "S_3": "Recyclage :",
      "T_3": "indiquer le code de reprise visible sur votre certificat de cession"
    },
    "PACKAGE_INFO": {
      "PACKAGE": "Forfait n°",
      "ESTIMATE": "Demander un devis de réparation",
      "REPAIR_TIME": "Délai moyen de réparation",
      "REPAIR_COST": "Forfait de réparation",
      "TRANSPORT_COST": "Frais de transport",
      "ESTIMATE_TRANSPORT_COST": "Coût de transport estimatif pour le transport aller",
      "ADDITIONAL_COST": "Frais de gestion",
      "REPAIR_FUND": "Fond de réparation",
      "REPAIR_AMOUNT": "Montant réparation",
      "WITH_DIAGNOSTIC": "selon diagnostic",
      "DIAGNOSTIC_COST": "Frais de diagnostic par réparateur (si refus)",
      "DAYS": "jours",
      "ESTIMATE_PACKAGE": "Envoyer le devis du forfait",
      "PRODUCT_NEW_PRICE": "Prix de vente public"
    },
    "MODAL": {
      "PACKAGE_ESTIMATE": {
        "TITLE": "Devis du forfait",
        "SUB_TITLE": "Envoyer la demande de devis forfait à:",
        "FILE_INPUT": {
          "PACKAGE": "Fiche SAV Client"
        },
        "PLACEHOLDER": {
          "COMPANY_NAME": "Nom de l'entreprise",
          "EMAIL_CONTACT": "Adresse mail de contact",
          "COMMENT": "Commentaire"
        },
        "VALIDATION_BUTTON": "Envoyer",
        "BOTTOM_TEXT": "Une fois le devis du forfait envoyé au client, le dossier sera sauvegardé et modifiable",
        "MESSAGE": {
          "VALIDATION": "Un email a été transmis avec succès à votre client avec le devis du forfait"
        }
      }
    }
  },
  "FILE_STEP_CREATE_FOLDER": {
    "TITLE": "Information client",
    "SUB_TITLE": {
      "GENERAL_INFORMATION": "Information du contact Entreprise pour la gestion de ce SAV",
      "ATTACHMENT": "Pièce à joindre avec le dossier"
    },
    "FORM": {
      "NAME": "Nom du client",
      "COMPANY": "Nom de l'Entreprise",
      "MAIL": "Adresse mail",
      "PHONE": "Numéro de téléphone",
      "COMPANY_SELECTOR": "Sélectionner l’entreprise dans la liste déroulante"
    },
    "HELP_TEXT": {
      "RULES": "Merci de renseigner toutes les informations concernant le contact client pour le suivi du dossier",
      "RULES_ERP": "Afin de générer un numéro de commande automatiquement sur votre ERP, sélectionner entreprise",
      "RGPD_RULES": "*RGPD : Une fois le dossier clôturé, les données indiquées avec ** seront automatiquement supprimées",
      "COMPANY_NOT_FOUND_RULE": "Vous ne trouvez pas votre entreprise ? Cliquez ici, et indiquez son nom"
    },
    "FILE_INPUT": {
      "BILLING": "Facture client",
      "EXTENSION_GUARANTEE": "Extension de garantie",
      "ASBESTOS_SHEET": "Déclaration amiante",
      "FORCE_GUARANTEE": "Pièce justificative forcer la prise en charge",
      "DEFAULT": "File supported: pdf, jpg, png",
      "DEFAULT_WARNING": "Pièce manquante à fournir",
      "DEFAULT_WARNING_ASBESTOS": "Pièce optionnel manquante"
    },
    "MODAL": {
      "TITLE": {
        "BILLING": "Justificatif de date d'achat",
        "EXTENSION_GUARANTEE": "Justificatif de date d'extension garantie",
        "ASBESTOS_SHEET": "Certificat amiante",
        "FORCE_GUARANTEE": "Justificatif pour forcer la prise en charge"
      },
      "BUTTON": {
        "VALIDATE": "Envoyer"
      }
    }
  },
  "FILE_STEP_STORE_INTERNAL": {
    "TITLE": "Information interne du magasin",
    "FORM": {
      "INTERNAL_COMMAND_NUMBER": "Numéro de commande fournisseur",
      "INTERNAL_COMMAND_NUMBER_HINT": "Si vous souhaitez modifier le N° de commande fournisseur : utilisez 11 caractères MAXIMUM, uniquement des MAJUSCULES et SANS ESPACE. La bonne coordination avec les réparateurs est essentielle : tout écart rendra le suivi plus complexe"
    }
  },
  "FILE_STEP_TRANSPORT_MODALITY": {
    "TITLE": "Transport",
    "SUB_TITLE": {
      "ADDRESS_INFORMATION": "1. Information adresse",
      "TRANSPORTER_INFORMATION": "2. Choix transport"
    },
    "SELECT": {
      "MODALITY_TYPE": {
        "TITLE": "Sélectionnez les modalités de transport :",
        "TRANSPORTER": "Envoi à un réparateur",
        "WORKSHOP": "Dépôt en main propre au réparateur",
        "STORE": "Réparation / Gestion par le magasin",
        "EXCLUDING_SUPPORT": "Hors process"
      },
      "ADDRESS": {
        "TITLE": "Renseigner les adresses :"
      }
    },
    "CARD_STEP_ONE": {
      "TITLE": {
        "SEND_FROM": "Départ",
        "SEND_TO": "Réparateur",
        "RECEIVE_TO": "Retour"
      },
      "NAME": "Nom adresse",
      "ADDRESS": "Adresse",
      "COMPLEMENT_ONE": "Compl.1",
      "COMPLEMENT_TWO": "Compl.2",
      "ZIP_CODE": "CP ville",
      "CONTACT_NAME": "Nom du contact",
      "CONTACT_EMAIL": "Email du contact",
      "CONTACT_PHONE": "Téléphone du contact"
    },
    "CARD_STEP_TWO": {
      "BATTERY": "Batterie de ",
      "WATT_HOUR": "Wh",
      "EXPRESS": "Messagerie Obligatoire"
    },
    "CARD_TRANSPORTER": {
      "TITLE": "Gestion immédiate",
      "TITLE_WHITE_LIST": "Indisponible",
      "TYPE": "Expressiste",
      "OPERATOR_MARKET": "Opéré par le magasin",
      "NO_TRANSPORTER": "Aucun transporteur trouvé"
    },
    "CARD_CUSTOMER_SERVICE": {
      "TYPE": "Si Chronopost n'est pas actionnable (Dimension hors standards),  cliquez sur cette option pour demander un transport spécifique (Messagerie).",
      "TYPE_BOOMERANG": "Le fabricant exige un process spécifique. Cliquer sur cette option pour que votre équipe SIEGE ou PARTENAIRE s'en charge et vous partage l'étiquette transport adéquate."
    },
    "CARD_WITHOUT_TRANSPORTER": {
      "TITLE": "",
      "TYPE": "Finaliser le dossier avec une autre solution de transport"
    },
    "SELECT_MATERIAL": {
      "TITLE": "Matériel à déclarer",
      "WEIGHT": "Poids colis",
      "BIGGEST_WIDTH": "Plus grande largeur",
      "BIGGEST_LENGTH": "Plus grande longueur",
      "KILOGRAM": "kg",
      "CENTIMETER": "cm"
    },
    "PLACEHOLDER": {
      "MODALITY_TYPE": "Modalités de transport"
    },
    "BUTTON": {
      "NEXT": "Prochaine étape",
      "VALIDATION": "Programmer l’expédition"
    },
    "MODAL": {
      "ADDRESS": {
        "TITLE": {
          "SEND_FROM": "Adresse de départ",
          "SEND_TO": "Adresse du réparateur",
          "RECEIVE_TO": "Adresse de Retour"
        },
        "NAME": "Nom de l'adresse",
        "NUMBER": "Numéro",
        "STREET": "Rue",
        "COMPLEMENT_ONE": "Complement 1",
        "COMPLEMENT_TWO": "Complement 2",
        "ZIP_CODE": "CP",
        "CITY": "Ville",
        "CONTACT_NAME": "Nom du contact",
        "CONTACT_EMAIL": "Email du contact",
        "CONTACT_PHONE": "Numéro de téléphone du contact",
        "PLACEHOLDER": {
          "NAME": "Nom de l'adresse",
          "NUMBER": "6 bis",
          "STREET": "Rue de la bourse",
          "COMPLEMENT_ONE": "Appartement, bureau, ...",
          "COMPLEMENT_TWO": "Notes sur l'adresse",
          "ZIP_CODE": "01000",
          "CITY": "Paris"
        },
        "VALIDATION_BUTTON": "Envoyer"
      },
      "BATTERY": {
        "TITLE": "Caractéristiques batterie",
        "MESSAGE": "Si elles sont endommagées pendant le transport, les batteries au lithium peuvent court-circuiter, ce qui peut provoquer une surchauffe et un départ de feu.\n\nL'expéditeur assume la responsabilité du transport et les couts associés en cas d’accident et est tenu de s'assurer que les éléments dangereux sont correctement déclarés, emballées et étiquetées avec la bonne documentation.\n\nLe transport d’une batterie de plus de 100Wh n’est pas accepté par les expressistes (TNT, Chrono ou UPS) et doit donc passer par messagerie et obligatoirement être déclaré et étiquetés en fonction (étiquette disponible à la fin de la procédure)",
        "TEXT_INPUT": {
          "VOLTAGE": "Voltage de la batterie",
          "AMPERAGE": "Ampérage de la batterie",
          "CHECKBOX": "Cas spécifiques:\nDEWALT : Je confirme avoir installé le capot spécifique sur la batterie FLEXVOLT, permettant ainsi de la transporter via expressiste\nFESTOOL : Je confirme avoir mis la POWERSTATION sur position OFF, permettant ainsi de la transporter via expressiste"
        },
        "EXPRESS": {
          "YES": "Expressiste autorisé",
          "NO": "Messagerie Obligatoire"
        },
        "PLACEHOLDER": {
          "VOLTAGE": "18 V",
          "AMPERAGE": "8Ah"
        }
      },
      "MANUFACTURER_TRANSPORTER": {
        "TITLE": "Demande d’un transport auprès du service client du réparateur",
        "SUB_TITLE": "Envoyer la demande d’un transporteur au réparateur par email:",
        "FILE_INPUT": {
          "ORDER": "Ordre de réparation",
          "PACKAGE": "Fiche SAV client"
        },
        "INFORMATION": {
          "TITLE": "Information complémentaires",
          "NUMBER": "Contact du service client du réparateur",
          "ERP_REPAIRER_NUMBER": "Votre numéro client",
          "INTERNAL_COMMAND_NUMBER": "Votre numéro de commande"
        },
        "VALIDATION_BUTTON": "Envoyer et finaliser le dossier",
        "BOTTOM_TEXT": "Suite à cette demande, le dossier sera sauvegardé dans l’attente de l’étiquette “TRANSPORT”",
        "MESSAGE": "Email envoyé avec succès"
      }
    }
  },
  "SHIPPING_PAGE": {
    "TITLE": {
      "SHIPPING": "Expédition"
    },
    "DEPARTURE": "Départ",
    "UPDATE_DEPARTURE": "Modification adresse de depart",
    "DELIVERY": "Destination",
    "CHRONOPOST_CONSTRAINTS": "Contraintes Chronopost",
    "COLLECT_SUBTITLE": "Générer une étiquette mais ne pas déclancher de ramasse :",
    "EARLY_COLLECT": "Heure de première collecte",
    "LAST_COLLECT": "Heure de dernière collecte",
    "MAX_CREATION": "Heure de demande maximale",
    "SHIPPING_DAY": "Date d'expédition",
    "WISHED_COLLECT_DATE": "Ramassage souhaité le :",
    "WISHED_DELIVERY_DATE": "Livraison souhaitée le :",
    "DETAIL_SHIPPING": "Détail de votre expédition",
    "MISSING_DATA": "Si les dimensions sont inconnu mettre les champs à 0",
    "LENGTH": "Longueur (cm)",
    "WIDTH": "Largeur (cm)",
    "HEIGHT": "Hauteur (cm)",
    "PACKAGE": "Colis",
    "MESSAGE": {
      "SUCCESS": {
        "FEASIBILITY_MESSAGE": "Le test de faisabilité est valide",
        "GENERATE_MESSAGE": "La demande de collecte a bien été généré"
      },
      "ERROR": {
        "HANDLE_UNIT_SHIPPED": "L'unité de manutention est expédiée."
      }
    },
    "BUTTON": {
      "FEASIBILITY": "Vérifier l'envoi",
      "GENERATE_SEND": "Générer la demande d'envoi"
    },
    "PLACEHOLDER" : {
      "CHRONOPOST_SERVICE": "Sélectionner votre service chronopost"
    }
  },
  "REPAIR_FILE_FINALIZATION": {
    "TITLE": "Demande de réparation n° %{internal_command_number} déclenchée",
    "SUB_TITLE": {
      "TRACKING_NUMBER": "1.Renseignez le numéro de tracking de l’expédition du produit",
      "TRACKING_NUMBER_INFO": "Indiquer un N° de dossier Réparateur ou un commentaire pour terminer la création du dossier",
      "PRINT": "2. Documents à imprimer",
      "SHARE": "3. Partager les éléments du dossier"
    },
    "CHECKBOX": {
      "CLIENT_SHARE": "Avec le client :",
      "PREPARER_SHARE": "Avec le préparateur logistique :",
      "COMMERCIAL_SHARE": "Avec équipe commerciale :"
    },
    "BUTTON": {
      "REPAIRER_PRINT": "Documents pour réparateur",
      "VALIDATION": "Terminer le dossier",
      "BACK": "Terminer plus tard"
    },
    "CARD": {
      "TRANSPORTER_ORDER": "Etiquette de transport",
      "REPAIR_ORDER": "Ordre de réparation",
      "BILLING": "Facture client",
      "GUARANTEE": "Extension de garantie",
      "FORCE_GUARANTEE": "Garantie forcée",
      "ASBESTOS": "Déclaration amiante",
      "AFTER_SALE_SERVICE": "Fiche SAV client",
      "DANGER_LABEL": "Etiquette produit dangereux",
      "TRANSPORTER_ORDER_INFO": "(à coller sur colis)",
      "REPAIR_ORDER_INFO": "(à mettre dans le colis)"
    }
  },
  "CURRENT_REPAIR_FILES": {
    "TITLE": "Dossier en cours",
    "SEE_MORE": "Voir plus",
    "DOWNLOAD": "Télécharger",
    "TABLE": {
      "REPAIR_FILE_BOOMERANG_ID": "Dossier",
      "PRODUCT_NAME": "Nom du produit",
      "COMPANY_NAME": "Nom de l'entreprise",
      "MANUFACTURER_NAME": "Marque",
      "STATUS": "Statut",
      "TIME": "Temps",
      "MODALITY": "Prise en charge",
      "LOADING_REPAIR_FILES": "Chargements des dossiers en cours...",
      "NO_REPAIR_FILE": "Aucun dossier en cours"
    },
    "MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin"
    },
    "DAYS": "jours"
  },
  "REPAIR_FILE_LIST_PAGE": {
    "FILTER": "Filtrer",
    "EXPORT": "Exporter",
    "EXPORT_REQUEST_SUCCESS": "La demande de génération de l'export est correctement faite. Le fichier sera envoyé par mail d'ici quelques minutes.",
    "EXPORT_REQUEST_FAILED": "La demande de génération de l'export a échoué.",
    "DELETE_FILTER": "Effacer les filtres",
    "TABLE": {
      "REPAIR_FILE_BOOMERANG_ID": "Dossier",
      "STORE_NAME": "Nom Magasin",
      "COMPANY_NAME": "Entreprise",
      "MANUFACTURER_NAME": "Marque",
      "PRODUCT_NAME": "Produit",
      "RENTAL": "Location",
      "STATUS": "Statut",
      "TIME": "Temps",
      "DATE": "Date",
      "MODALITY": "Pris en charge",
      "LOADING_REPAIR_FILES": "Chargements des dossiers...",
      "NO_REPAIR_FILE": "Aucun dossier"
    },
    "MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin",
      "EXCLUDING_SUPPORT": "Hors process"
    },
    "FILTERS": {
      "USER_ACTION": "Dossiers nécessitant une action",
      "CURRENT_FOLDER": "Dossiers en cours uniquement",
      "DATE_CREATION": "Date de création",
      "RENTAL": "Avec dossier de location uniquement"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionnez la marque",
      "STATUS_MACRO": "Sélectionnez le statut",
      "MODALITY": "Sélectionnez la modalité",
      "STORE": "Sélectionnez le(s) magasin(s)"
    },
    "DAYS": "jours"
  },
  "REPAIR_FILE_DETAIL": {
    "INTERNAL_COMMAND_NUMBER": "N° ",
    "STORE": "Magasin : ",
    "CLIENT_COMPANY_NAME": "Entreprise : ",
    "MESSAGE": {
      "DELETE": {
        "SUCCESS": "Le dossier a été supprimé avec succès"
      },
      "RELAUNCH": {
        "SUCCESS": "Le dossier a été relancé"
      },
      "STATUS_MACRO_UNKNOWN": "Statut du dossier est inconnu",
      "DRAFT": "Le dossier n'a pas encore atteint l'étape de création",
      "DELETED": "Le dossier a été supprimé",
      "NOT_FOUND": "Le dossier n'a pas été trouvé"
    },
    "MODAL": {
      "DELETE_REPAIR_FILE": {
        "TITLE": "Supprimer le dossier",
        "MESSAGE": "Voulez-vous vraiment supprimer le dossier?",
        "WARNING": "Cette action est irréversible."
      },
      "CUSTOMER_RELAUNCH": {
        "TITLE": "Relance Client",
        "MESSAGE": "Voulez vous vraiment valider la relance de ce dossier ?"
      }
    },
    "HEADER_RENTAL": {
      "REPAIR": "Réparation",
      "RENTAL": "Location"
    }
  },
  "REPAIR_FILE_DETAIL_ACTION_DRAWER": {
    "TITLE": "Nouvelle action",
    "SUB_TITLE": {
      "CUSTOMER_SUPPORT": "Prise en charge"
    },
    "LAST_RELAUNCH": "Dernière relance : ",
    "CUSTOMER_ESTIMATE_REVISION": "Reprendre le dossier",
    "REPAIRER_ESTIMATE": "Devis réparateur",
    "ADD_ESTIMATE_TO_FILE": "Intégrer le devis du réparateur au dossier",
    "NOTIFY_THE_REPAIRER": "Reprendre le devis du réparateur",
    "CLOSE_CASE": "Clôture",
    "RETRIEVE_EQUIPMENT_CUSTOMER": "Clôturer le dossier",
    "BUTTON": {
      "CUSTOMER_RELAUNCH_BY_PHONE": "Client relancé par téléphone",
      "CHANGE_STATUS": "Changer statut",
      "ADD_RENTAL": "Ajouter une piece jointe"
    }
  },
  "REPAIR_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "IN_CREATION": "1.   En création",
      "TRANSPORT_GO": "2.   Enlèvement aller",
      "RECEPTION_AT_REPAIRER": "3.   Réception chez réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "4.   Devis envoyé par le fabricant",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "5.   Intégration Devis Fabricant",
      "ESTIMATE_SENT_TO_CUSTOMER": "6.   Devis envoyé au client",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "7.   Décision client envoyée au réparateur",
      "IN_REPARATION": "8.   En réparation",
      "SENT_BACK_BY_REPAIRER": "9.   Expédition par réparateur",
      "RECEIPT_AT_STORE": "10.   Reception en magasin",
      "SENT_AVAILABLE_TO_CUSTOMER": "11.   Client informé dispo",
      "TAKEOVER_BY_CUSTOMER": "12.   Remise au client - Cloturé",
      "NETWORK_BILLING": "13.   Facturation",
      "FINISHED": "14.   Dossier Terminé"
    },
    "REPAIR_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Produit",
        "SUPPORT": "Prise en charge",
        "CONTACT": "Contact entreprise",
        "PRICING": "Tarification",
        "PROSPECT_FLOW": "Demande de prise en charge préalable"
      },
      "PRODUCT": "Produit :",
      "MANUFACTURER": "Marque :",
      "CATEGORY": "Gamme :",
      "SUB_CATEGORY": "Sous-gamme :",
      "SERIAL_NUMBER": "Numéro de série :",
      "LASTNAME": "Nom de l'interlocuteur :",
      "EMAIL": "Email :",
      "PHONE_NUMBER": "Téléphone :",
      "SUPPORT": "Prise en charge :",
      "ELEMENT": "Eléments concernés :",
      "GUARANTEE": "Garantie initiale :",
      "UNDER_GUARANTEE": "Sous garantie",
      "OUT_GUARANTEE": "Hors garantie",
      "TRANSPORT_COST": "Coût transport :",
      "TRANSPORT_PRICE": "Prix transport :",
      "MANAGEMENT_COST": "Coût gestion :",
      "MANAGEMENT_PRICE": "Prix gestion :",
      "REPAIR_COST": "Prix de réparation estimatif (HT):",
      "REPAIR_FUND": "Fond de réparation :",
      "PACKAGE_CODE": "Code forfait fabricant :",
      "PACKAGE_TOTAL_COST": "Coût total (HT) :",
      "PACKAGE_SUPPORT_COST": "Prix de la prise en charge (HT) :",
      "NETWORK_PACKAGE_CODE": "Code forfait distributeur :",
      "ESTIMATE": "Cout devis réparation :",
      "ESTIMATE_VALIDATE_BY_CUSTOMER": "Offre validée par client :",
      "ESTIMATE_VALIDATE_TAKEOVER_BY_CUSTOMER": "Offre finale client :",
      "ESTIMATE_VALIDATE_COST": "Coût facturé par réparateur (HT) :",
      "ESTIMATE_VALIDATE_DETAIL_ESTIMATE_COST": "Coût facturé par réparateur (HT) :",
      "ESTIMATE_VALIDATE_DETAIL_TRANSPORT_COST": "Coût transport (HT) :",
      "ESTIMATE_VALIDATE_DETAIL_LABOR_COST": "Coût main d'œuvre (HT) :",
      "ESTIMATE_VALIDATE_DETAIL_REPAIR_COST": "Coût total de la réparation (HT) :",
      "ESTIMATE_VALIDATE_TRANSPORT_COST": "Prix transport (inclus dans prise en charge) (HT) :",
      "ADDITIONAL_REPAIR_COST": "Prix gestion :",
      "CUSTOMER_END_COST": "Prix total client (HT) :",
      "REPAIR_FILE_IN_PROGRESS": "Dossier en cours",
      "TAKEOVER_BY_CUSTOMER": "Remis au client",
      "NO_PRICE": "- €",
      "CLIENT_LABEL": "Client",
      "REPAIRER_LABEL": "Réparateur",
      "REPAIRER_COST_MAX": "Coût de réparation max (HT) :",
      "COMMENT": "Commentaires :"
    },
    "ESTIMATE_OPTION_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_RECYCLED": "Non réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non réparation : retour de la machine démontée",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Echange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "emande préalable : Autre"
    },
    "HEADER": {
      "TITLE": "Récapitulatif demande de réparation",
      "DAYS": " jours",
      "DAY": " jour"
    },
    "BUTTON": {
      "NEW_ACTION": "Nouvelle action"
    },
    "ERROR": {
      "MANUAL_UPDATE_INVALID": "La mise a jour manuelle de ce status est impossible"
    }
  },
  "REPAIR_FILE_ATTACHMENT": {
    "TITLE": "Pièces jointes",
    "CARD": {
      "TRANSPORTER_ORDER": "Étiquette expédition",
      "REPAIR_ORDER": "Ordre de réparation",
      "BILLING": "Facture client",
      "GUARANTEE": "Extension de garantie",
      "FORCE_GUARANTEE": "Garantie forcée",
      "ASBESTOS": "Déclaration amiante",
      "AFTER_SALE_SERVICE": "Fiche SAV client",
      "DANGER_LABEL": "Etiquette produit dangereux",
      "INFO": "(à coller sur colis)",
      "ESTIMATE_PACKAGE": "Devis du forfait",
      "GUARANTEE_EXTENSION_BOOMERANG": "Certificat de garantie Boomerang",
      "REPAIR_FILE_PROSPECT_ORDER_WAITING": "Demande préalable"
    },
    "MODAL": {
      "FILE": "Ajouter votre pièce jointe",
      "FILE_NAME": "Nom du fichier",
      "GENERIC_TITLE": "Ajouter une pièce jointe",
      "GENERIC_SUBTITLE": "Sélectionnez le mode d'ajout",
      "INPUT_LABEL_BY_PC": "Via votre ordinateur",
      "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
      "PC_TITLE": "Ajouter une pièce jointe via ordinateur",
      "QR_CODE_TITLE": "Ajouter une pièce jointe via QR Code",
      "QR_CODE_SUBTITLE": "Pour ajouter la pièce jointe, scannez le QRCode."
    },
    "PROSPECT_PICTURE_NAME_LABEL": "Photo-",
    "PROSPECT_DOCUMENT_NAME_LABEL": "Document-"
  },
  "REPAIR_FILE_DELIVERY_CLIENT_DRAWER": {
    "TITLE": "Clôture du dossier",
    "SUB_TITLE": {
      "GUARANTEE_INFORMATION": "Information pour prolongation de garantie 6 mois",
      "BILLING_NUMBER": "Numéro Commande Fournisseur",
      "INITIAL_INFORMATION": "Information initiale du dossier",
      "BILLING_CLIENT_COST": "Montant facturé au client (HT)",
      "INTERNAL_PROJECT_INFORMATION": "Code fournisseur",
      "REFERENCE": "Référence",
      "PACKAGE_DESIGNATION": "Désignation forfait",
      "REPAIR_CHANGE_COST": "Prise en charge :",
      "TRANSPORT": "Transport :",
      "MANAGEMENT": "Gestion :",
      "REF_ERP": "Référence ERP "
    },
    "DETAIL": {
      "SUBTITLE": "Conditions pour extension de garantie Boomerang (jusqu’à 6 mois)",
      "FIRST_CONDITION": "1. Faire partie de la gamme électroportatif (hors batterie et chargeur)",
      "SECOND_CONDITION": "2. Renseigner tous les champs ci-dessous avec précision",
      "THIRD_CONDITION": "3. Le numéro de série doit être unique",
      "FOURS_CONDITION": "4. La réparation doit avoir été réalisée dans un atelier agréé par la marque",
      "DELIVERY_DATE_1": "La date du jour est enregistrée automatiquement.",
      "DELIVERY_DATE_2": "Si vous souhaitez la modifier, sélectionnez une date."
    },
    "PRODUCT_END_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_RECYCLED": "Non réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non réparation : retour de la machine démontée"
    },
    "SELECT": {
      "END_STATUS": "Sélectionnez le statut final du produit",
      "PRODUCT_BOOMERANG_NAME": "Identifiant du produit",
      "SELECT_PRODUCT": "Sélectionnez un produit",
      "PRODUCT_END_COST": "Coût total facturé par le réparateur (HT)",
      "SERIAL_NUMBER": "Numéro de série",
      "EURO": "€",
      "TOTAL": "Total: "
    },
    "PLACEHOLDER": {
      "END_STATUS": "Sélectionnez le statut final du produit",
      "PRODUCT": "Sélectionnez le produit",
      "SEARCH": "999 999 999 999"
    },
    "BUTTON": {
      "SERIAL_NUMBER": "Trouver le numéro de série"
    },
    "MESSAGE": {
      "PRODUCT_BOOMERANG_ID_NOT_FOUND": "Votre dossier n’est pas disponible pour le moment.",
      "PROLONGATION_GUARANTEE_FOUND": "Le numéro de série de ce produit possède déjà une prolongation de garantie.",
      "GENERIC_SERIAL_NUMBER": "Ce numéro de série est générique et le produit ne bénéficiera pas de garantie automatique."
    }
  },
  "INFORMATION_REPAIR_FILE": {
    "CLIPBOARD_COPY": "Adresse de contact magasin copiée dans le presse-papiers",
    "CLIPBOARD_COPY_ERROR": "Erreur lors de la copie dans le presse-papiers",
    "CONTENT": "Prise en charge :",
    "REPAIR_CENTER": {
      "ADDRESS": "Adresse :",
      "EMAIL": "Adresse de contact :",
      "ERP_REPAIRER_NUMBER": "Numéro compte Réparateur :",
      "NAME": "Nom réparateur :",
      "PHONE": "Numéro de téléphone :",
      "REPAIRER_NUMBER": "Numéro de dossier réparateur :",
      "TITLE": "Réparateur"
    },
    "STORE": {
      "EMAIL": "Adresse de contact :",
      "TITLE": "Magasin"
    },
    "TITLE": "Informations",
    "TRANSPORTER_MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin",
      "EXCLUDING_SUPPORT": "Hors process"
    }
  },
  "COMMENTARY_REPAIR_FILE": {
    "TITLE": "Commentaire",
    "PLACEHOLDER": {
      "COMMENTARY": "Ajouter un commentaire"
    }
  },
  "TRANSPORTER_RENTAL_FILE": {
    "GO_TO": "Aller",
    "TRANSPORTER_GO": "Transport aller",
    "ADDRESS_NAME": "Nom adresse :",
    "ADDRESS": "Adresse :",
    "ADDRESS_COMPLEMENT_1": "Complément 1 : ",
    "ADDRESS_COMPLEMENT_2": "Complément 2 : ",
    "CITY": "Ville :",
    "COUNTRY": "Pays : ",
    "DESIRED_RECEPTION_DATE": "Date de livraison souhaitée : ",
    "TRACKING_NUMBER": "Numéro de suivi : ",
    "TRANSPORTER_TYPE": "Transporteur : ",
    "TRANSPORT_SEND_DATE": "Date d'envoi : "
  },
  "TRANSPORTER_REPAIR_FILE": {
    "GO_TO": "Aller",
    "RETURN_TO": "Retour",
    "TRANSPORTER_GO": "Transport aller",
    "ADDRESS_NAME": "Nom adresse :",
    "ADDRESS": "Adresse :",
    "CITY": "Ville :",
    "TRANSPORT_TYPE": "Type de transport :",
    "TRANSPORTER": "Transporteur :",
    "FINALIZATION_DATE": "Date finalisation dossier :",
    "COLLECT_STATUS": "Demande de ramasse :",
    "EXPEDITION_DATE": "Date expédition :",
    "TRACKING_NUMBER": "Numéro de tracking :",
    "TRANSPORTER_LOGIN": "Login du contrat transporteur :",
    "TYPE": {
      "IMMEDIATE_TRANSPORTER": "Transporteur immédiat",
      "CUSTOMER_SERVICE_TRANSPORTER": "Transporteur du service client",
      "WITHOUT_TRANSPORTER": "Sans transporteur"
    },
    "TRANSPORTER_NAME": {
      "CHRONOPOST": "Chronopost"
    }
  },
  "CUSTOMER_RECOVERY": {
    "TITLE": "Relance client",
    "REMINDER": "Rappels",
    "LAST_FOLLOW_UP": "Dernière relance le: ",
    "DIALOGUE": {
      "MESSAGE": "Voulez vous vraiment cacher cette relance ?",
      "VALIDATION_BUTTON": "Oui",
      "CANCEL_BUTTON": "Non"
    }
  },
  "PUBLIC": {
    "OPTION": {
      "SUCCESS_EMAIL_SEND_WITH_ATTACHMENT": "Les informations et la pièce jointe sont bien ajoutées au dossier.",
      "ERROR_PROSPECT_MANUFACTURER_RESPONSE_INFORMATION_SEND": "L'envoi des informations est bloqué - Contacter %{supportAddress}"
    },
    "ESTIMATE_REPAIRER_CLIENT_OPTION": {
      "TITLE": "Merci pour votre retour !",
      "MESSAGE": "Votre décision sur la réparation a bien été prise en compte par votre magasin",
      "PURCHASE_ORDER_MESSAGE": "Si vous devez envoyer un bon de commande à votre magasin, cliquez ci-dessous",
      "PURCHASE_ORDER_FORM_MESSAGE": "Formulaire du bon de commande",
      "TOGGLE_TEXT": "Ajouter une pièce jointe",
      "TOGGLE_MESSAGE": "File supported: pdf, jpg, png",
      "FORM": {
        "ORDER_NUMBER": "N° de commande",
        "CALLBACK_REF": "Référence à rappeler",
        "ATTACHMENT": "Ajouter votre pièce jointe"
      }
    },
    "ESTIMATE_PACKAGE_CLIENT_OPTION": {
      "TITLE": "Merci pour votre retour !",
      "MESSAGE": "Votre décision sur le devis de réparation a bien été prise en compte par votre magasin",
      "PURCHASE_ORDER_MESSAGE": "Si vous devez envoyer un bon de commande à votre magasin, cliquez ci-dessous",
      "PURCHASE_ORDER_FORM_MESSAGE": "Formulaire du bon de commande",
      "TOGGLE_TEXT": "Ajouter une pièce jointe",
      "TOGGLE_MESSAGE": "File supported: pdf, jpg, png",
      "FORM": {
        "ORDER_NUMBER": "N° de commande",
        "CALLBACK_REF": "Référence à rappeler",
        "ATTACHMENT": "Ajouter votre pièce jointe"
      }
    }
  },
  "ESTIMATE_REPAIRER": {
    "TITLE": "Devis réparateur",
    "TITLE_CHOICE": "Choix du client",
    "REPAIRER_NUMBER": "Numéro de devis indiqué par votre réparateur",
    "PLACEHOLDER": {
      "REPAIRER_NUMBER": "N°1234"
    },
    "HINT": {
      "REPAIRER_NUMBER": "Pour la bonne prise en charge de votre dossier, merci d’indiquer uniquement le N° de devis fourni par le réparateur.\nDans le cas de BOSCH, il s’agit impérativement du N° d’Ordre (exemple : 2506230xxx ou 0306000xxx)."
    }
  },
  "ESTIMATE_REPAIRER_OFFER": {
    "SUB_TITLE": "Offre du réparateur",
    "TITLE_FORM": "Veuillez indiquer les coûts du fabricant",
    "TRANSPORT_COST": "Coût réparateur dont transport",
    "LABOR_COST": "Coût réparateur dont transport & main d'œuvre",
    "MARGIN": "Marge",
    "MODIFICATION_MARGIN": "Modifier marge",
    "MODIFICATION_PRICE": "Modifier prix",
    "SAVE_MARGIN": "Sauvegarder marge",
    "SAVE_PRICE": "Sauvegarder prix",
    "INFO_CLIENT": "N'oubliez pas d'inclure une option de non-réparation pour le client",
    "PLACEHOLDER": {
      "OFFER_TYPE": "Type d'offre",
      "COMMENT": "Détail pour client",
      "ESTIMATE_COST": "Coût de réparation ou du matériel",
      "LABOR_COST": "Coût de la main d'œuvre",
      "TRANSPORT_COST": "Coût de transport",
      "END_STATUS": "N°1234"
    },
    "BUTTON": {
      "ADD_FORM": "Ajouter une offre du réparateur"
    }
  },
  "ESTIMATE_REPAIRER_DETAIL": {
    "SUB_TITLE": {
      "SUMMARY": "Montant à proposer au client (HT)",
      "INFORM_CLIENT": "Informer le client"
    },
    "CUSTOMER_EMAIL_SAVE": " L'email du client a été sauvegardé",
    "CALL_CLIENT": "J’appelle le client et l’informe des tarifs",
    "SEND_ESTIMATE": "Envoyer un devis avec ces options",
    "BUTTON": {
      "SEND_EMAIL": "Envoyer les options par email",
      "RESPONSE_CLIENT": "Le client me répond tout de suite",
      "CANCEL": "Reprendre le devis plus tard"
    },
    "PLACEHOLDER": {
      "COMMENT": "Commentaire"
    },
    "MODAL": {
      "SEND_CLIENT_EMAIL": "Les options ont bien été envoyées par mail au client"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE": {
    "SUB_TITLE": "Offre du réparateur",
    "SAVE_MARGIN": "Sauvegarder marge",
    "SAVE_PRICE": "Sauvegarder prix",
    "MODIFICATION_MARGIN": "Modifier marge",
    "MODIFICATION_PRICE": "Modifier prix",
    "MARGIN": "Marge",
    "TRANSPORT_COST": "Coût réparateur dont transport",
    "LABOR_COST": "Coût réparateur dont transport & main d'œuvre",
    "SEND_ESTIMATE_AGAIN": "Renvoyer le devis par email",
    "BUTTON": {
      "SEND_EMAIL": "Renvoyer les options du devis par email"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION": {
    "TITLE": "Informer le réparateur et le client",
    "SUB_TITLE": {
      "CONTACT_REPAIRER": "1. Confirmer au réparateur le coût de la réparation",
      "CONTACT_CLIENT": "2. Confirmer au client la validation"
    },
    "BUTTON": {
      "SAVE": "Confirmer par mail automatiquement",
      "CANCEL": "Reprendre le devis plus tard"
    },
    "VALIDATION": "Les options ont bien été envoyées par mail au client et au réparateur"
  },
  "UPDATE_STATUS_FORM_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE": "Mettez à jour le statut du dossier et sélectionnez la date si différente de la\ndate du jour et validez",
    "PLACEHOLDER": "Statut disponible"
  },
  "UPDATE_STATUS_CONFIRMATION_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE": "Voulez vous vraiment mettre à jour le statut du dossier? Cette action est irréversible.",
    "FORCE_ESTIMATE_STATUS_MESSAGE_1": "Attention! A la validation de ce statut, vous ne pourrez pas ajouter de devis dans Boomerang.",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_1": "Pour ajouter un devis, cliquer sur",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_2": "Nouvelle action",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_3": "puis",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_4": "Intégrer le devis au dossier",
    "SUB_MESSAGE": "La date de mise à jour est enregistrée automatiquement. Si vous souhaitez la modifier, sélectionnez une date.",
    "PASS_MESSAGE": "Ajouter les photos via les pièces jointes",
    "RECEIPT_AT_STORE_TITLE": "Informez votre client que son produit a été retourné",
    "PHONE_NOTIFICATION": {
      "TITLE": "Par téléphone",
      "CALL": "Appel",
      "SMS": "SMS"
    },
    "TAKEOVER_TYPE": {
      "TITLE": "Par email",
      "PICK_UP": "Produit dispo en magasin",
      "SEND_BY_STORE": "Produit va être livré par le magasin"
    }
  },
  "NOTIFICATION": {
    "BUTTON": {
      "MORE": "Voir plus"
    },
    "LOADING_NOTIFICATION": "Chargement des notifications",
    "NO_NOTIFICATION": "Aucune notification a afficher"
  },
  "TRANSPORTER_PAGE": {
    "TITLE": {
      "HEADER": "Transporteurs",
      "EXPRESSIST": "Expressistes"
    },
    "BUTTON": {
      "EXPRESSIST_ADD_BUTTON": "Ajouter un transporteur",
      "EXPRESSIST_UPDATE_BUTTON": "Modifier le transporteur"
    }
  },
  "EXPRESSIST_TRANSPORTER": {
    "DETAIL_PAGE": {
      "STORE_MODAL": {
        "TITLE": "Sélection du magasin",
        "MESSAGE": "Sélectionnez le magasin concerné pour configurer le transporteur",
        "PLACEHOLDER": "Magasin"
      },
      "TITLE": {
        "GENERAL_INFORMATION": "Informations générales du transporteur",
        "CONNEXION_GENERAL_INFORMATION": "Informations générales de la connexion",
        "NO_TRANSPORTER": "Vous n'avez pas encore défini de transporteur pour votre magasin.",
        "HEADER": "Détail du transporteur",
        "SUBTITLE": "Transporteur - %{transporter_name}"
      },
      "LABEL": {
        "TRANSPORTER_NAME": "Nom du transporteur",
        "TRANSPORTER_TYPE": "Transporteur type",
        "TRANSPORTER_WEIGHT": "Poids maximal",
        "TRANSPORTER_POWER": "Puissance maximal",
        "TRANSPORTER_HEIGHT": "Hauteur maximal",
        "TRANSPORTER_WIDTH": "Largeur maximal",
        "CONNEXION_NAME": "Nom de la connexion",
        "CONNEXION_IDENTIFIER": "Identifiant de connexion",
        "CONNEXION_PASSWORD": "Mot de passe de connexion",
        "CONNEXION_SERVICE": "Service de la connexion",
        "LINK_PRIORITY": "Utilisation de ce transporteur en priorité"
      }
    },
    "CREATE_PAGE": {
      "TITLE": {
        "HEADER": "Ajouter votre transporteur",
        "SUBTITLE": "Formulaire d'ajout du transporteur"
      },
      "BUTTON": {
        "CREATE_TRANSPORTER": "Ajouter ce transporteur"
      },
      "MESSAGE": {
        "SUCCESS": "Le transporteur a été créé avec succès"
      }
    },
    "UPDATE_PAGE": {
      "TITLE": {
        "HEADER": "Éditer votre transporteur",
        "SUBTITLE": "Formulaire d'édition du transporteur"
      },
      "BUTTON": {
        "UPDATE_TRANSPORTER": "Éditer ce transporteur"
      },
      "MESSAGE": {
        "SUCCESS": "Le transporteur a été édité avec succès"
      }
    },
    "FORM": {
      "LABEL": {
        "TRANSPORTER_TYPE": "Type de transporteur",
        "CONNEXION_SERVICE": "Service(s)",
        "CONNEXION_IDENTIFIER": "Identifiant de connexion",
        "CONNEXION_PASSWORD": "Mot de passe de connexion",
        "LINK_PRIORITY": "Utilisation de ce transporteur en priorité"
      }
    },
    "LIST_PAGE": {
      "TABLE": {
        "NAME": "Nom du transporteur",
        "LOADING_MESSAGE": "Chargement des expressistes...",
        "EMPTY_MESSAGE": "Aucun expressiste"
      },
      "MODAL": {
        "TITLE": "Suppression d’un expressiste",
        "MESSAGE": "Voulez-vous vraiment supprimer %{transporter}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS": "L'expressiste a été supprimé avec succès"
      },
      "BUTTON": {
        "NEW_EXPRESSIST": "Ajouter un expressiste"
      },
      "DELETE_MODAL": {
        "TITLE": "Suppression de la connexion",
        "MESSAGE": "Voulez-vous vraiment supprimer connexion ?",
        "WARNING": "Cette action est irréversible."
      }
    }
  },
  "GUARANTEE_EXTENSION_BOOMERANG_MODAL": {
    "TITLE": "Extension de garantie de réparation",
    "BODY_1": "Le produit de votre client est sous garantie jusqu'au",
    "BODY_2": "Cette date est visible sur le certificat d'extension de garantie rattaché au dossier que vous pouvez imprimer ci-dessous.",
    "SEND_BY_EMAIL_MESSAGE": "Partager le certificat par email",
    "PROOF_TITLE": "Certificat d'extension de garantie",
    "SUCCESS_SENT": "Le certificat a bien été envoyé a l'adresse email"
  },
  "RENTAL_MODULE_LIST_PRODUCTS_PAGE": {
    "TITLE": "Bienvenue sur BOOMERANG Location",
    "SELECT_ALL": "Tout",
    "BRAND": "Marque",
    "CATEGORY_GROUP": "Catégories",
    "AVAILABILITY_STATUS_GROUP": "Disponibilité",
    "AVAILABILITY_STATUS": {
      "AVAILABLE": "Disponible",
      "IN_COMING": "A venir",
      "UNAVAILABLE": "Indisponible"
    },
    "AVAILABILITY_ERROR": "Vous ne pouvez pas sélectionner un produit non disponible"
  },
  "RENTAL_MODULE_PRODUCT_DETAIL_PAGE": {
    "DEPOSIT": "Caution",
    "CONSUMABLE_TEXT": "Pensez à proposer ces consommables",
    "SUMMARY_TEXT": "Demander un contrat de location",
    "HT_PRICE": "Sous total",
    "DELIVERY_TOTAL": "Livraison à partir de:",
    "FREE_DELIVERY": "GRATUIT",
    "HT_TOTAL": "Total HT",
    "CREATE_RENT_BUTTON": "Créer un contrat de location"
  },
  "RENTAL_MODULE_CREATE_FILE_PAGE": {
    "NEXT_STEP_CARD": {
      "TITLE": "Prochaines étapes pour valider la demande de location",
      "P1": "1. Renseigner l’ensemble des informations sur le formulaire de droite et envoyer la demande de location",
      "P2": "2. Sous 1h le client reçoit son contrat par email via WeSign et la demande de caution par email et téléphone via Swikly (si caution par gérée par le magasin)",
      "P3": "3. Envoi de la machine par transporteur à l’adresse et date de livraison souhaitée*, une fois le contrat signé et la caution validée",
      "P3_DOT": "*les demandes gérées avant 11h sont livrés à J+1 et les demandes gérées après 11h sont livrés à J+2",
      "P4": "4. Réception et utilisation de la machine le temps de la réparation",
      "P5": "5. Une fois le produit réparé, le client est informé par le magasin. Le client a 48h pour retourner la machine en magasin",
      "SP2": "Surcout contractuel",
      "SP2_1": "passé 48h 29 € seront facturés par jour supplémentaire",
      "SP2_2": "si la machine n’est pas retournée dans l’état initial un forfait de nettoyage de 29€ pourrait être appliqué",
      "P6": "6. Envoi de la machine par le magasin à Boomerang",
      "P7": "7. Vérification de la machine et déblocage de la caution par Boomerang"
    },
    "FORM": {
      "TITLE": "Formulaire contrat de location",
      "COMPANY_NAME_LABEL": "Nom d'entreprise",
      "CLIENT_FULLNAME_LABEL": "Nom du signataire du contrat",
      "CLIENT_EMAIL_LABEL": "E-mail du signataire du contrat",
      "CLIENT_PHONE_NUMBER_LABEL": "Téléphone du signataire",
      "COMPANY_ADDRESS_NAME_LABEL": "Nom de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_NUMBER_LABEL": "Numéro de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_STREET_LABEL": "Rue de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_ZIP_CODE_LABEL": "Code postal de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_CITY_LABEL": "Ville de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_COUNTRY_LABEL": "Pays de l'adresse de l'entreprise",
      "BILLING_ADDRESS_STATUS_LABEL": "Adresse de livraison similaire à l’adresse de facturation",
      "BILLING_ADDRESS_NAME_LABEL": "Nom de l'adresse de facturation",
      "BILLING_ADDRESS_NUMBER_LABEL": "Numéro de l'adresse de facturation",
      "BILLING_ADDRESS_STREET_LABEL": "Rue de l'adresse de facturation",
      "BILLING_ADDRESS_ZIP_CODE_LABEL": "Code postal de l'adresse de facturation",
      "BILLING_ADDRESS_CITY_LABEL": "Ville de l'adresse de facturation",
      "BILLING_ADDRESS_COUNTRY_LABEL": "Pays de l'adresse de facturation",
      "DESIRED_DELIVERY_DATE_LABEL": "Date de livraison souhaitée: ",
      "DEPOSIT_LABEL": "Comment s'organise le dépôt de caution: ",
      "DEPOSIT_VALUE_1_LABEL": "Caution gérée par le distributeur sur le compte du client",
      "DEPOSIT_VALUE_2_LABEL": "Caution en ligne via Boomerang et son partenaire Swikly (max 4.50€ de dossier)",
      "COMMENT_LABEL": "Commentaire",
      "COMMENT_PLACEHOLDER": "Commentaire spécifiques (Ex: Le client ne sera pas présent à l'atelier)",
      "CONTRACT_LABEL": "Consulter les conditions générales de location courte durée",
      "CARD_LABEL": "Conditions générales de location",
      "VALIDATION": "Envoyer la demande de location"
    }
  },
  "RENTAL_FILE_DETAIL": {
    "BOOMERANG_ID": "N° ",
    "STORE": "Magasin : ",
    "CLIENT_COMPANY_NAME": "Entreprise : ",
    "CLIENT_NAME": "Client : ",
    "NOT_FOUND": "Le dossier de location n'a pas pu être trouvé",
    "STATUS_UNKNOWN": "Statut du dossier de location inconnu",
    "STATUS": {
      "CREATED": "Création du dossier",
      "CONTRACT_SENT": "Envoi contrat",
      "PACKET_PREPARATION": "Préparation Colis",
      "TRANSPORT_GO": "Transport aller",
      "CLIENT_RECEIPT": "Réception client",
      "CLIENT_INFORMED": "Client informé dispo",
      "STORE_RECEIPT": "Réception location en magasin",
      "TRANSPORT_BACK": "Transport Retour",
      "BOOMERANG_RECEIPT": "Réception Boomerang",
      "BILLING": "Facturation hors cadre",
      "CLOSED": "Clôture"
    }
  },
  "COMMENTARY_RENTAL_FILE": {
    "TITLE": "Commentaire",
    "PLACEHOLDER": {
      "COMMENTARY": "Ajouter un commentaire"
    }
  },
  "DAY_SUPP_COUNT_DATE_RENTAL_FILE": {
    "TITLE_1": "Nombre de jours additionnels",
    "TITLE_2": "(A partir de J+2 du retour SAV)",
    "DAYS": "Jours"
  },
  "RENTAL_FILE_ATTACHMENT": {
    "TITLE": "Pièces jointes",
    "CARD": {
      "CGV": "CGV",
      "ADD_ATTACHMENT": "Ajouter une pièce jointe"
    },
    "MODAL": {
      "FILE_NAME": "Nom du fichier",
      "FILE": "Ajouter votre pièce jointe"
    },
    "PERMISSION": {
      "VIEW_ATTACHMENT_DENIED": "Vous n'avez pas les droits pour voir les pieces jointes",
      "PRINT_ATTACHMENT_DENIED": "Vous n'avez pas les droits pour telecharger cette piece jointe"
    }
  },
  "RENTAL_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "CREATED": "1. Création du dossier",
      "CONTRACT_SENT": "2. Envoi contrat",
      "PACKET_PREPARATION": "3. Préparation Colis",
      "TRANSPORT_GO": "4. Transport aller",
      "CLIENT_RECEIPT": "5. Réception client",
      "CLIENT_INFORMED": "6. Client informé dispo",
      "STORE_RECEIPT": "7. Réception location en magasin",
      "TRANSPORT_BACK": "8. Transport Retour",
      "BOOMERANG_RECEIPT": "9. Réception Boomerang",
      "BILLING": "10. Facturation hors cadre",
      "CLOSED": "11. Clôture"
    },
    "HEADER": {
      "TITLE": "Récapitulatif demande de location",
      "DAYS": " jours",
      "DAY": " jour"
    },
    "RENTAL_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Produit",
        "CONTACT": "Contact entreprise",
        "PRICING": "Tarification"
      },
      "MANUFACTURER": "Marque :",
      "CATEGORY": "Gamme :",
      "SUB_CATEGORY": "Sous-gamme :",
      "PRODUCT": "Produit :",
      "SERIAL_NUMBER": "Numéro de série :",
      "LASTNAME": "Nom du signataire :",
      "EMAIL": "Email :",
      "PHONE_NUMBER": "Téléphone :",
      "CLIENT_RENTAL_COST": "Prix client location :",
      "CLIENT_RENTAL_COST_PACKAGE_NAME": "Forfait client location :",
      "CLIENT_ADDITIONAL_DAY_COST": "Prix client / jour additionnel :",
      "CLIENT_ADDITIONAL_DAY_PACKAGE_NAME": "Forfait client / jour additionnel :",
      "DEPOSIT": "Caution :",
      "DEPOSIT_TYPE": "Dépôt de caution :"
    },
    "DEPOSIT_TYPE": {
      "STORE": "Magasin",
      "SWIKLY": "Swikly"
    }
  },
  "RENTAL_UPDATE_STATUS_STORE_RECEIPT_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une photo du produit.",
    "MESSAGE_2": "Pour ajouter une photo, scannez le QRCode et ajouter une photo du produit au dossier.",
    "ERROR": {
      "INVALID_RENTAL_FILE_QR_CODE_TOKEN_NOT_USED_ERROR_KEY": "Aucune photo du produit n'a été ajoutée au dossier. Merci d'ajouter au moins une photo pour passer à l'étape suivante."
    }
  },
  "RENTAL_FILE_ADD_PICTURE": {
    "TITLE": "Ajout des photos du Produit",
    "MESSAGE": "Veuillez ajouter une ou plusieurs photos du produit",
    "SELECT_TITLE": "Sélectionner vos photos :",
    "TITLE_SENT": "Merci, vos photos sont collectées ; il vous suffit de cliquer sur le bouton \"confirmer l'ajout des photos\" sur la plateforme afin de les enregistrer dans le dossier.",
    "MESSAGE_SENT": "Dans le cas ou vous devriez ajouter une autre photo, refaite la manipulation en activant un nouveau QR Code avec votre appareil photo.",
    "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
    "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG"
  },
  "STEP_PROSPECT": {
    "TITLE": "Information dossier",
    "SUB_STEP_INFORMATION_CLIENT": {
      "TITLE": "1. Information du contact Entreprise pour la gestion de ce SAV"
    },
    "SUB_STEP_PROSPECT_REQUEST": {
      "TITLE": "2. Demande de prise en charge préalable",
      "RIGHT_PART": {
        "ADD_PICTURE": {
          "TITLE": "Ajouter des photos demandées sur le modèle pour compléter le dossier",
          "SUBTITLE": "Cliquer sur l’option de votre choix ci-dessous",
          "INPUT_LABEL_BY_PC": "Via votre ordinateur",
          "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
          "ADD_SUCCESS": "Ajout de la photo fait avec succès",
          "REMOVE_SUCCESS": "Suppression de la photo fait avec succès",
          "PICTURE_NAME_LABEL": "Photo-"
        },
        "ADD_DOCUMENT": {
          "TITLE": "Ajouter des pièces supplémentaires à joindre au dossier",
          "INPUT_LABEL": "Ajouter un document",
          "ADD_SUCCESS": "Ajout du document fait avec succès",
          "REMOVE_SUCCESS": "Suppression du document fait avec succès",
          "DOCUMENT_NAME_LABEL": "Document-"
        },
        "MORE_INFO": {
          "TITLE": "Détailler les informations permettant de faciliter la prise en charge",
          "SUBTITLE": "(Désignation modèle exact si non précisé précédemment, Référence Fournisseur, Taille, Couleur, etc)",
          "INPUT_LABEL": "Exemple : la fermeture éclair a arraché toutes les coutures"
        }
      },
      "MESSAGE": {
        "SENT_SUCCESS": "La demande a était envoyé avec succès",
        "PARTIAL_SUCCESS": "Le dossier est sauvegardé avec succès"
      },
      "BUTTON": {
        "VALIDATE": "Valider la demande préalable"
      },
      "MODAL": {
        "TITLE": "Demande de prise en charge préalable au réparateur",
        "PROSPECT_PDF_LABEL": "Demande de prise en charge",
        "TITLE_EMAIL": "Envoyer la demande au réparateur par email:",
        "PLACEHOLDER_EMAIL": "Email du réparateur",
        "INFORMATION": "Tous les documents et commentaires seront envoyés au réparateur pour un diagnostic complet.",
        "VALIDATION_BUTTON": "Envoyer au réparateur",
        "BOTTOM_TEXT": "Suite à cette demande, le dossier sera sauvegardé dans l'attente du retour du réparateur"
      },
      "PICTURE_MODAL": {
        "TITLE": "Ajout des photos par QR Code",
        "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une photo.",
        "MESSAGE_2": "Pour ajouter une photo, scannez le QRCode et ajouter une photo au dossier.",
        "VALIDATION_BUTTON": "Confirmer l'ajout des photos",
        "SENT_SUCCESS": "Merci, vos photos sont bien ajoutées au dossier"
      },
      "PICTURE_PC_MODAL": {
        "TITLE": "Ajout des photos",
        "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une photo.",
        "VALIDATION_BUTTON": "Confirmer l'ajout des photos",
        "SENT_SUCCESS": "Merci, vos photos sont bien ajoutées au dossier"
      }
    },
    "SUB_STEP_PROSPECT_RESPONSE": {
      "TITLE": "3. Retour du fabricant après demande de prise en charge",
      "MANUFACTURER_SUPPORT_LABEL": "Prise en charge par le fabricant",
      "MANUFACTURER_OPTION": {
        "PRODUCT_REPAIR_WITH_GUARANTEE": "Réparation sous garantie",
        "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Demande de retour du produit pour diagnostique",
        "CREDIT_OR_REFUND": "Avoir / Remboursement",
        "PRODUCT_REPLACEMENT": "Echange par un produit neuf",
        "REJECT_PROSPECT": "Refus - Non réparation et clôture du dossier",
        "OTHER": "Autre"
      },
      "MESSAGE": {
        "VALIDATE_SUCCESS": "Validation de la réponse du fabricant sauvegardée"
      },
      "MODAL": {
        "TITLE": "Confirmer le retour du fabricant",
        "MESSAGE": "La confirmation engendre des actions sur le dossier, vous ne pourrez pas revenir en arrière"
      }
    }
  },
  "REPAIR_FILE_PROSPECT_ADD_PICTURE": {
    "TITLE": "Ajout des photos du Produit",
    "MESSAGE": "Veuillez ajouter une ou plusieurs photos du produit",
    "SELECT_TITLE": "Sélectionner vos photos :",
    "TITLE_SENT": "Merci, vos photos sont collectées ; il vous suffit de cliquer sur le bouton \"confirmer l'ajout des photos\" sur la plateforme afin de les enregistrer dans le dossier.",
    "MESSAGE_SENT": "Dans le cas ou vous devriez ajouter une autre photo, refaite la manipulation en activant un nouveau QR Code avec votre appareil photo.",
    "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
    "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG"
  },
  "PUBLIC_PROSPECT": {
    "TITLE": "Merci pour votre retour !",
    "MESSAGE": "Votre décision sur la demande de prise en charge a bien été prise en compte",
    "MANUFACTURER_INFO_MESSAGE": "Renseigner le détail du dossier dans les champs ci-dessous",
    "SUPPORT_NUMBER_LABEL": "N° de la demande de prise en charge",
    "MANUFACTURER_COMMENT_LABEL": "Commentaire",
    "MANUFACTURER_ATTACHMENT_LABEL": "Ajouter une pièce jointe",
    "TITLE_FORM_SENT": "Merci, les informations ont bien été sauvegardées"
  },
  "RENTAL_WARNING_MODAL": {
    "TITLE": "Noubliez pas de récupérer le produit en location",
    "MESSAGE": "Attention! Un dossier de location est lié au dossier de réparation. Avant de clôturer le dossier pensez à récupérer la machine en location et clôturer le dossier."
  },
  "ATTACHMENT_MODAL": {
    "PC_MODAL": {
      "TITLE": "Ajout de la piece jointe",
      "MESSAGE": "Pour mettre à jour le dossier vous devez ajouter une piece jointe.",
      "MESSAGE_WARNING": "Attention, une pièce jointe existe déjà. Si vous en ajoutez une nouvelle, elle va remplacer l'existante.",
      "INPUT_LABEL": "Via votre ordinateur",
      "VALIDATION_BUTTON": "Confirmer l'ajout de la pièce jointe",
      "SELECT_TITLE": "Sélectionner votre pièce jointe :",
      "TITLE_SENT": "Merci, votre pièce jointe est bien ajoutée au dossier",
      "MESSAGE_SENT": "Vous pouvez à présent poursuivre sur la plateforme"
    },
    "QR_CODE_MODAL": {
      "TITLE": "Ajout de la piece jointe par QR Code",
      "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une piece jointe.",
      "MESSAGE_2": "Pour ajouter la pièce jointe, scannez le QRCode.",
      "MESSAGE_WARNING": "Attention, une pièce jointe existe déjà. Si vous en ajoutez une nouvelle, elle va remplacer l'existante.",
      "VALIDATION_BUTTON": "Confirmer l'ajout de la pièce jointe"
    },
    "QR_CODE_PAGE": {
      "TITLE": "Ajout de la piece jointe",
      "MESSAGE": "Pour mettre à jour le dossier vous devez ajouter une piece jointe.",
      "SELECT_TITLE": "Sélectionner votre pièce jointe :",
      "TITLE_SENT": "Merci, votre pièce jointe est bien ajoutée au dossier",
      "MESSAGE_SENT": "Vous pouvez à présent poursuivre sur la plateforme",
      "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG"
    }
  },
  "RECYCLING_MODULE": {
    "RECYCLING_PAGE": {
      "TITLE": "Recyclage de matériel Professionnel ",
      "GREEN": {
        "TITLE": "Recycler avec BOOMERANG",
        "TEXT_1": "Les Équipements Électriques et Électroniques (EEE) contiennent des matières polluantes pour l’environnement, mais représentent aussi un fort potentiel de recyclage des matériaux qui les composent.",
        "TEXT_2": "La démarche est établie par les éco-organismes en charge de la filière de recyclage des piles et accumulateurs portables ainsi que les eco-organismes DEEE."
      },
      "MAIN": {
        "TITLE": "Rapport de recyclage",
        "REPORT": {
          "RECYCLER": {
            "TITLE": "Nombre de produits recyclés"
          },
          "BUYBACK": {
            "TITLE": "Valeur de rachat recyclage"
          }
        },
        "BAC": {
          "TITLE": "Seuils des bacs de retour"
        },
        "BATTERIES": {
          "TITLE": "Consultez la procédure de conditionnement et stockage du Lithium"
        },
        "RECYCLED_PRODUCT_LIST": {
          "TITLE": "Téléchargez le listing complet des produits recyclés"
        },
        "TABLE": {
          "LOADING": "Chargements des BAC en cours...",
          "EMPTY": "Aucun BAC trouvé",
          "BUTTON": "Déclencher la ramasse",
          "COLLECTION_TRIGGER_SUCCESS": "Votre demande de ramasse est bien communiquée. Le partenaire prendra rapidement contact avec vous"
        }
      },
      "BUTTON": {
        "NEW_RECYCLING_FOLDER": "Recycler un nouveau produit"
      }
    },
    "STEPPER": {
      "TITLE": "Recyclage de matériel Professionnel",
      "STEP": {
        "PRODUCT_INFORMATION": "Informations du produit",
        "PRODUCT_CHECKING": "Verification",
        "PRODUCT_PACKAGING": "Conditions de stockage"
      }
    },
    "STEP_PRODUCT_INFORMATION": {
      "TITLE": "Enregistrement de mon produit",
      "TITLE_CONDITION": "État du produit",
      "NO_PICTURE": "Sélectionnez votre produit",
      "FORM":{
        "LABEL": {
          "COMPANY_NAME": "Nom de l'entreprise",
          "DEPOSIT_DATE": "Date de dépot",
          "MANUFACTURER": "Marque",
          "PRODUCT": "Rechercher mon produit",
          "PRODUCT_NOT_FOUND": "Mon produit n’est pas dans la liste",
          "ADD_PRODUCT_MESSAGE": "Vous pensez que votre produit a de la valeur ? Contactez Boomerang par le Chat ou au 06 69 51 56 64",
          "SERIAL_NUMBER": "Numéro de série"
        },
        "PLACEHOLDER": {
          "COMPANY_NAME": "Votre entreprise",
          "MANUFACTURER": "Rechercher ma marque",
          "PRODUCT": "Rechercher mon produit",
          "SERIAL_NUMBER": "999 999 999 999"
        }
      }
    },
    "STEP_PRODUCT_CHECKING": {
      "RECYCLER": {
        "TITLE": "Vérification de l'état",
        "SUB_1": "Oups, cette machine ne peut pas être reprise...",
        "SUB_2": "Mais elle a encore de la valeur !",
        "TEXT_1": "Confiez-la nous pour un recyclage responsable.",
        "TEXT_2": "Nous trierons ses composants avec soin : les matières premières récupérable seront réutilisées ou transmises à nos partenaires spécialisés pour un recyclage optimal.",
        "TEXT_3": "Ensemble, donnons une seconde vie aux matériaux."
      },
      "RECONDITIONER": {
        "TITLE": "Vérification de l'état",
        "SUB_1": "Ajouter des photos du produit",
        "TEXT_1": "Rajouter une photo permettra au prestataire de valoriser la reprise du produit. Pour cela, intégrez 2 photos :",
        "TEXT_2": "1. Une photo de la plaque signalétique",
        "TEXT_3": "2. Une photo de la machine à plat",
        "ADD_ATTACHMENT": {
          "INPUT_LABEL_BY_PC": "Via votre ordinateur",
          "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
          "ADD_SUCCESS": "Ajout de la photo fait avec succès",
          "REMOVE_SUCCESS": "Suppression de la photo fait avec succès",
          "PICTURE_NAME_LABEL": "Photo-"
        },
        "ATTACHMENT_PC_MODAL": {
          "TITLE": "Ajout des photos",
          "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une photo.",
          "VALIDATION_BUTTON": "Confirmer l'ajout des photos",
          "SENT_SUCCESS": "Merci, vos photos sont bien ajoutées au dossier"
        },
        "ATTACHMENT_QR_CODE_MODAL": {
          "TITLE": "Ajout des photos par QR Code",
          "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une photo.",
          "MESSAGE_2": "Pour ajouter une photo, scannez le QRCode et ajouter une photo au dossier.",
          "VALIDATION_BUTTON": "Confirmer l'ajout des photos",
          "SENT_SUCCESS": "Merci, vos photos sont bien ajoutées au dossier"
        },
        "CGU_LABEL": "J’ai bien pris en compte que le prix de reprise est proposé sous réserve que la machine soit bien dans l'état déclaré. Une photo de la machine est ajoutée pour confirmer la cession et assurer la traçabilité de l’équipement."
      },
      "CONDITION_LABEL": "État",
      "BUYBACK_PRICE_LABEL": "Reprise :",
      "BUYBACK_PRICE_CLIENT_LABEL": "Montant reversé au client :",
      "BUYBACK_PRICE_STORE_LABEL": "Montant conservé par le magasin :"
    },
    "STEP_PRODUCT_PACKAGING": {
      "TITLE": "Conditions de stockage",
      "CONDITION_LABEL": "État",
      "BUYBACK_PRICE_LABEL": "Reprise :",
      "BAC_DESIGNATION_LABEL": "Recyclage :",
      "DOWNLOAD_LINK_TEXT": "Télécharger le certificat de cession du produit",
      "FORM": {
        "MAIL": "Envoyer le certificat par email"
      },
      "PLACEHOLDER": {
        "MAIL": "E-mail"
      },
      "BATTERY_WARNING": {
        "WITHOUT_BATTERY": "DANGER Batterie ! Je déclare qu'aucune batterie n'est recyclée avec ce produit (Responsabilité engagée du magasin)",
        "WITH_BATTERY": "DANGER Batterie ! Je recycle une batterie et respecte les conditions de stockage (Responsabilité engagée du magasin) - Voir condition de stockage"
      },
      "MODAL": {
        "TITLE": "Confirmation",
        "MESSAGE": "En validant cette étape, vous confirmez que le client a été informé de la cession immédiate de son produit envers votre entreprise. Votre entreprise devient donc propriétaire/responsable de ce produit dans l'attente d'une future cession à un tier."
      },
      "SUCCESS": "Le dossier a bien été enregistré"
    },
    "RECYCLING_ADD_ATTACHMENT": {
      "TITLE": "Ajout des photos du Produit",
      "MESSAGE": "Veuillez ajouter deux photos du produit",
      "SELECT_TITLE": "Sélectionner vos photos :",
      "TITLE_SENT": "Merci, vos photos sont collectées ; il vous suffit de cliquer sur le bouton \"confirmer l'ajout des photos\" sur la plateforme afin de les enregistrer dans le dossier.",
      "MESSAGE_SENT": "Dans le cas ou vous devriez ajouter une autre photo, refaite la manipulation en activant un nouveau QR Code avec votre appareil photo.",
      "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG"
    },
    "RECYCLING_REPORT_PAGE": {
      "TITLE": "Analyse performance environnementale",
      "GREEN": {
        "TITLE": "Rapport de votre performance environnementale",
        "TEXT_1": "Gorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus.",
        "DESCRIPTION": "Retrouvez toutes nos sources :",
        "LINK_1": "Référentiel de calcul",
        "LINK_2": "Sources ADEME",
        "LINK_3": "Note Méthodologique de calculateur",
        "LINK_4": "Note méthodologique des ACV"
      },
      "BUTTON": {
        "DOWNLOAD_REPORT": "Télécharger le Rapport"
      },
      "MAIN": {
        "REPORT": {
          "WORLD_TOUR_TITLE": "Tours du monde évités par la réduction des transports",
          "CO2": "CO2 évités",
          "MATERIALS": "Tonnes de matières premières non extraites"
        },
        "SELECT": {
          "STORE": "Sélectionnez votre magasin",
          "MANUFACTURER": "Sélectionnez la marque"
        },
        "TABLE": {
          "HEADER": {
            "CURRENT_YEAR": "Nb de dossiers (année en cours)",
            "LAST_YEAR": "Nb dossiers (année n-1)",
            "TWO_YEAR": "Nb dossiers (année n-2)",
            "IMPACT_MATERIAL": "Impact Matière protégée (kg) (année n-1)",
            "CO2_IMPACT": "Impact CO2 (Kg) (année n-1)"
          },
          "REPAIR_ROW": "Réparation",
          "REPAIR_ECOSYSTEM_ROW": "Produits calculés et référencés via ACV ECOSYSTEM - BOOMERANG",
          "REPAIR_PROXY_ROW": "Produits étudiés par Proxi ACV Ademe + Autres sources",
          "REPAIR_WITHOUT_ROW": "Produits sans étude préalable",
          "REUSE_ROW": "Réemploi",
          "REUSE_ECOSYSTEM_ROW": "Produits calculés et référencés via ACV ECOSYSTEM - BOOMERANG",
          "REUSE_PROXY_ROW": "Produits étudiés par Proxi ACV Ademe + Autres sources",
          "REUSE_WITHOUT_ROW": "Produits sans étude préalable",
          "RECYCLED_ROW": "Recyclage",
          "RECYCLED_BY_BOOMERANG_ROW": "Via BOOMERANG",
          "RECYCLED_BY_REPAIRER_ROW": "Autres",
          "RENTAL_ROW": "Location pendant réparation",
          "WITHOUT_INFORMATION_ROW": "Sans Information",
          "TOTAL": "TOTAL ACTIONS"
        }
      }
    }
  }
}

